var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var edit = require('../../layout/components/edit');
var loaders = require('../../layout/components/loaders');
var c3 = require('../../libs/chart');
var Point = require('../../data/models/point');
var debounce = require('lodash/debounce');
var helpModal = require('../../help/helpModal');
var choices = require('../../libs/choices');
var button = require('../../components/button');
var pikaday = require('../../libs/pikaday');
var modalForm = require('../../layout/components/modalForm');
var modal = require('../../layout/components/modal');
var elementForm = modalForm(require('../models/element'));
var equipmentModel = require('../../equipment/models/equipment');
var getEquipmentLocationRid = require('../utils/getEquipmentLocationRid');
var classPointSelection = require('../utils/classPointSelection');
var dateFormat = 'MM/DD/YYYY hh:mm A';

var smartChart = {
  oninit: function (vnode) {
    var ctrl = this;
    ctrl.element = vnode.attrs.element;
    ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
    ctrl.dashboardCallback = vnode.attrs.dashboardCallback;

    ctrl.loading = prop(false);
    ctrl.error = prop(null);
    ctrl.datasets = prop([]);
    ctrl.visiblePoints = prop(new Set());
    ctrl.pointsMeta = new Map();
    ctrl.pathKeyToCanonicalRid = new Map();
    ctrl.ridToPathKey = new Map();
    ctrl.maxVisibleChoices = 8;
    ctrl.pendingSeries = [];
    ctrl.pendingSeriesClear = false;
    ctrl.isExpanded = prop(false);
    ctrl.hasInitialized = false;
    ctrl.form = {
      start: prop(null),
      span: prop(null),
      resampling: prop(null),
      valueField: prop(null)
    };
    ctrl.controlsOpen = prop(false);
    ctrl.modalClickRoot = null;
    ctrl.modalClickListening = false;
    ctrl.latestSeriesData = new Map();
    ctrl.lastRequestedField = 'mean';
    ctrl.chartRefreshing = prop(false);
    // Track refresh requests so only the latest response updates the chart
    ctrl.refreshSequence = 0;
    ctrl.latestRefreshRequestId = 0;
    ctrl.legendCollapsed = prop(!edit.vm.editing());
    ctrl._legendPreviousEditing = edit.vm.editing();
    ctrl.variant = typeof vnode.attrs.variant === 'string' ? vnode.attrs.variant : 'default';
    ctrl.hideTitle = Boolean(vnode.attrs.hideTitle);
    ctrl.pointRecord = vnode.attrs.pointRecord;
    ctrl.pointColumn = vnode.attrs.column;
    ctrl.expandedCloseIconMargin = typeof vnode.attrs.expandedCloseIconMargin === 'string' ? vnode.attrs.expandedCloseIconMargin : '';
    ctrl.isBuilderVariant = function () {
      return ctrl.variant === 'chartBuilder';
    };
    ctrl.isPointBrowseVariant = function () {
      return ctrl.variant === 'pointBrowse';
    };
    ctrl.builderFragment = vnode.attrs.builderFragment || ('chart-builder-' + Math.random().toString(36).slice(2));
    ctrl.builderClassOptions = prop([]);
    ctrl.selectedClasses = prop([]);
    ctrl.builderClassesLoaded = prop(false);
    ctrl.builderClassesError = prop(null);
    ctrl.builderSaving = prop(false);
    ctrl.builderSaveStatus = prop(null);
    ctrl.builderSaveIsError = prop(false);
    ctrl.builderSaveTimeoutId = null;
    ctrl.yBoundsOpen = prop(false);
    ctrl.yBoundsError = prop(null);
    ctrl.tempYMax = prop('');
    ctrl.tempYMin = prop('');
    ctrl.builderNameMaxLength = 64;

    ctrl.debouncedShift = debounce(function (shiftOptions) {
      if (!shiftOptions) { return Promise.resolve(); }
      return ctrl.refreshChartData(Object.assign({ type: 'shift' }, shiftOptions));
    }, 500, { leading: true, trailing: true });
    ctrl.seriesCache = new Map();
    ctrl.pendingSlide = null;
    ctrl.pendingShiftFlow = null;
    ctrl.pendingXDomain = null;
    ctrl.displayXDomain = null;
    ctrl.yAxisTransitionTimeoutId = null;
    ctrl.yAxisTransitionSequence = 0;
    ctrl.yAxisTransitionConfig = null;
    ctrl.chartStage = null;
    ctrl.activeSlideCleanup = null;
    ctrl.chartSlideSequence = 0;
    ctrl.chartAnimationDuration = 600;
    ctrl.yAxisAnimationDuration = 250;
    ctrl.clearBuilderStatus = function () {
      if (ctrl.builderSaveTimeoutId) {
        clearTimeout(ctrl.builderSaveTimeoutId);
        ctrl.builderSaveTimeoutId = null;
      }
    };
    ctrl.setBuilderStatus = function (message, isError) {
      ctrl.clearBuilderStatus();
      ctrl.builderSaveStatus(message || null);
      ctrl.builderSaveIsError(Boolean(isError));
      if (message) {
        ctrl.builderSaveTimeoutId = setTimeout(function () {
          ctrl.builderSaveStatus(null);
          ctrl.builderSaveIsError(false);
          m.redraw();
        }, 4000);
      }
      m.redraw();
    };
    ctrl.getElementRecord = function () {
      return (typeof ctrl.element === 'function') ? ctrl.element() : ctrl.element;
    };
    if (ctrl.isBuilderVariant()) {
      ctrl.selectedClasses([]);
      var initialElement = ctrl.getElementRecord();
      if (initialElement && Array.isArray(initialElement.equipmentClasses)) {
        initialElement.equipmentClasses = [];
      }
    }
    ctrl.syncTempYBounds = function () {
      var el = ctrl.getElementRecord();
      var maxValue = el && el.yMax != null ? el.yMax : '';
      var minValue = el && el.yMin != null ? el.yMin : '';
      ctrl.tempYMax(maxValue === '' ? '' : String(maxValue));
      ctrl.tempYMin(minValue === '' ? '' : String(minValue));
    };
    ctrl.closeYBoundsPopover = function () {
      ctrl.yBoundsOpen(false);
      ctrl.yBoundsError(null);
    };
    ctrl.handleModalDateControlsClick = function (event) {
      if (!ctrl.controlsOpen() || !ctrl.modalClickRoot) {
        return;
      }
      var target = event && event.target;
      if (!target || typeof ctrl.modalClickRoot.contains !== 'function' || !ctrl.modalClickRoot.contains(target)) {
        return;
      }
      if (typeof target.closest === 'function' && (
        target.closest('.smart-chart-date-edit') ||
        target.closest('.smart-chart-controls-popover') ||
        target.closest('.flatpickr-calendar')
      )) {
        return;
      }
      ctrl.controlsOpen(false);
      m.redraw();
    };
    ctrl.attachModalDateControlsListener = function (chartRoot) {
      if (!ctrl.isPointBrowseVariant() || !chartRoot || typeof chartRoot.closest !== 'function' || typeof document === 'undefined') {
        return;
      }
      var modalRoot = chartRoot.closest('#modal-id-to-focus');
      if (!modalRoot) {
        return;
      }
      ctrl.modalClickRoot = modalRoot;
      if (!ctrl.modalClickListening) {
        document.addEventListener('mousedown', ctrl.handleModalDateControlsClick, true);
        document.addEventListener('touchstart', ctrl.handleModalDateControlsClick, true);
        document.addEventListener('click', ctrl.handleModalDateControlsClick, true);
        ctrl.modalClickListening = true;
      }
    };
    ctrl.detachModalDateControlsListener = function () {
      if (ctrl.modalClickListening && typeof document !== 'undefined') {
        document.removeEventListener('mousedown', ctrl.handleModalDateControlsClick, true);
        document.removeEventListener('touchstart', ctrl.handleModalDateControlsClick, true);
        document.removeEventListener('click', ctrl.handleModalDateControlsClick, true);
      }
      ctrl.modalClickListening = false;
      ctrl.modalClickRoot = null;
    };
    ctrl.toggleYBoundsPopover = function (event) {
      if (event && typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }
      if (ctrl.yBoundsOpen()) {
        ctrl.closeYBoundsPopover();
        return;
      }
      ctrl.controlsOpen(false);
      ctrl.syncTempYBounds();
      ctrl.yBoundsError(null);
      ctrl.yBoundsOpen(true);
    };
    ctrl.parseAxisValue = function (value) {
      if (value == null) { return null; }
      var trimmed = String(value).trim();
      if (trimmed === '') { return null; }
      var numeric = Number(trimmed);
      if (!Number.isFinite(numeric)) {
        return null;
      }
      return numeric;
    };
    ctrl.loadBuilderClassOptions = async function () {
      if (!ctrl.isBuilderVariant()) {
        return;
      }
      ctrl.builderClassesLoaded(false);
      ctrl.builderClassesError(null);
      try {
        var tree = await equipmentModel.getClassTree();
        var classTree = tree && Array.isArray(tree.categories)
          ? tree
          : { categories: equipmentModel.equipmentClassTree.categories || [] };
        ctrl.builderClassOptions(classPointSelection.buildClassOptions(classTree));
        ctrl.builderClassesLoaded(true);
        m.redraw();
      } catch (err) {
        ctrl.builderClassOptions([]);
        ctrl.builderClassesError(err && err.message ? err.message : 'Unable to load classes.');
        ctrl.builderClassesLoaded(true);
        m.redraw();
      }
    };
    ctrl.applyYBounds = async function () {
      ctrl.yBoundsError(null);
      var maxValue = ctrl.parseAxisValue(ctrl.tempYMax());
      var minValue = ctrl.parseAxisValue(ctrl.tempYMin());
      if (maxValue != null && minValue != null && maxValue <= minValue) {
        ctrl.yBoundsError('Maximum must be greater than minimum.');
        return;
      }
      var el = ctrl.getElementRecord();
      if (el) {
        el.yMax = maxValue != null ? maxValue : undefined;
        el.yMin = minValue != null ? minValue : undefined;
      }
      ctrl.chartOptions.axis.y.max = maxValue != null ? maxValue : undefined;
      ctrl.chartOptions.axis.y.min = minValue != null ? minValue : undefined;
      if (ctrl.chart && ctrl.chart.axis) {
        if (typeof ctrl.chart.axis.max === 'function') {
          ctrl.chart.axis.max(maxValue != null ? maxValue : null);
        }
        if (typeof ctrl.chart.axis.min === 'function') {
          ctrl.chart.axis.min(minValue != null ? minValue : null);
        }
      }
      if (el && el['@rid']) {
        try {
          await loaders.requestWithLoader({
            url: '/api/v1/element/' + el['@rid'].slice(1),
            method: 'PUT',
            body: {
              yMax: maxValue != null ? maxValue : null,
              yMin: minValue != null ? minValue : null
            },
            loader: 'background',
            background: true
          });
        } catch (err) {
          console.error('Unable to save axis bounds.', err);
        }
      }
      ctrl.tempYMax(maxValue != null ? String(maxValue) : '');
      ctrl.tempYMin(minValue != null ? String(minValue) : '');
      ctrl.closeYBoundsPopover();
      ctrl.scheduleChartRefresh();
      m.redraw();
    };
    ctrl.clearYBounds = function () {
      ctrl.tempYMax('');
      ctrl.tempYMin('');
      return ctrl.applyYBounds();
    };
    ctrl.openBuilderNameModal = function (options) {
      options = options || {};
      var defaultName = typeof options.defaultName === 'string' ? options.defaultName : '';
      var onSubmit = typeof options.onSubmit === 'function' ? options.onSubmit : null;
      var nameValue = prop(defaultName);
      var errorMessage = prop(null);
      var inputId = ctrl.builderFragment + '-name-input';

      var handleSubmit = function () {
        var trimmed = (nameValue() || '').trim();
        if (!trimmed) {
          errorMessage('Please enter a chart name.');
          m.redraw();
          return;
        }
        if (trimmed.length > ctrl.builderNameMaxLength) {
          errorMessage('Chart name must be ' + ctrl.builderNameMaxLength + ' characters or fewer.');
          m.redraw();
          return;
        }
        modal.vm.close();
        if (onSubmit) {
          onSubmit(trimmed);
        }
        m.redraw();
      };

      var handleCancel = function () {
        modal.vm.close();
        m.redraw();
      };

      modal.vm.title('Save Smart Chart');
      modal.vm.body = function () {
        return m('form', {
          onsubmit: function (event) {
            event.preventDefault();
            handleSubmit();
          }
        }, [
          errorMessage() ? m('div.red.mb2', errorMessage()) : null,
          m('div.mb3', [
            m('label.db.mb1', { for: inputId }, 'Chart Name'),
            m('input.input-reset.w-100.pa2.ba.b--light-gray.bg-transparent.white', {
              id: inputId,
              type: 'text',
              value: nameValue(),
              maxlength: ctrl.builderNameMaxLength,
              oninput: function (event) {
                nameValue(event.target.value);
                if (errorMessage()) {
                  errorMessage(null);
                }
              },
              oncreate: function (vnode) {
                setTimeout(function () {
                  if (vnode.dom && typeof vnode.dom.focus === 'function') {
                    vnode.dom.focus();
                    if (typeof vnode.dom.select === 'function') {
                      vnode.dom.select();
                    }
                  }
                }, 0);
              }
            })
          ]),
        ]);
      };
      modal.vm.buttons([
        {
          label: 'Cancel',
          class: 'dib mr2 fl',
          func: handleCancel
        },
        {
          label: 'Save Chart',
          class: 'btn-good fr',
          func: handleSubmit
        }
      ]);
      modal.vm.open();
    };
    ctrl.executeBuilderSave = async function (options) {
      options = options || {};
      if (ctrl.builderSaving()) {
        return;
      }
      var elementRecord = options.elementRecord || ctrl.getElementRecord();
      if (!elementRecord || !elementRecord.parentRid) {
        ctrl.setBuilderStatus('Unable to locate a parent for this Chart.', true);
        return;
      }
      var chartName = typeof options.chartName === 'string' ? options.chartName.trim() : '';
      if (!chartName) {
        ctrl.setBuilderStatus('Please enter a chart name before saving.', true);
        return;
      }
      if (chartName.length > ctrl.builderNameMaxLength) {
        chartName = chartName.slice(0, ctrl.builderNameMaxLength);
      }
      var visiblePoints = Array.isArray(options.visiblePoints) ? options.visiblePoints.slice() : [];
      if (visiblePoints.length === 0) {
        ctrl.setBuilderStatus('Select at least one point before saving.', true);
        return;
      }
      var selectedClasses = Array.isArray(options.selectedClasses) ? options.selectedClasses.slice() : [];
      if (selectedClasses.length === 0) {
        ctrl.setBuilderStatus('Select at least one equipment class before saving.', true);
        return;
      }

      ctrl.builderSaving(true);
      ctrl.setBuilderStatus(null, false);
      try {
        var spanValueRaw = ctrl.form && ctrl.form.span ? ctrl.form.span() : null;
        var spanValue = Number(spanValueRaw);
        if (!Number.isFinite(spanValue) || spanValue <= 0) {
          spanValue = elementRecord.chartSpan || 8;
        }
        var resampleValue = ctrl.form && ctrl.form.resampling ? ctrl.form.resampling() : (elementRecord.chartResample || 'hours');
        var valueFieldCurrent = ctrl.form && ctrl.form.valueField ? ctrl.form.valueField() : elementRecord.smartChartValueField;
        var valueField = ctrl.normalizeValueField(valueFieldCurrent);
        var startValue = ctrl.form && ctrl.form.start ? ctrl.form.start() : null;
        var endingMoment = startValue;
        if (endingMoment && typeof endingMoment.clone === 'function') {
          endingMoment = endingMoment.clone();
        } else if (endingMoment && !moment.isMoment(endingMoment)) {
          endingMoment = moment(endingMoment);
        }
        var chartEnding = endingMoment && moment.isMoment(endingMoment) && endingMoment.isValid() ? endingMoment.toISOString() : null;
        var payload = {
          parent: elementRecord.parentRid,
          useHasElementEdge: true,
          type: 'smartchart',
          name: chartName,
          width: 4,
          chartSpan: spanValue,
          chartResample: resampleValue,
          smartChartValueField: valueField,
          equipmentClasses: selectedClasses.slice(),
          hiddenFields: {
            smartChartConfig: {
              visiblePoints: visiblePoints.slice()
            }
          }
        };
        if (chartEnding) {
          payload.chartEnding = chartEnding;
        }
        var created = await loaders.requestWithLoader({
          url: '/api/v1/element',
          method: 'POST',
          body: payload,
          loader: 'background'
        });
        var createdRid = created && (created['@rid'] || created.rid || created.id);
        if (!createdRid) {
          throw new Error('Missing element RID from response.');
        }
        var ridString = typeof createdRid === 'string' ? createdRid : (createdRid['@rid'] || createdRid.rid || '');
        if (!ridString) {
          throw new Error('Unable to determine element RID.');
        }
        var ridFragment = ridString.charAt(0) === '#' ? ridString.slice(1) : ridString;
        var updatePayload = {
          hiddenFields: payload.hiddenFields,
          smartChartValueField: valueField,
          chartSpan: spanValue,
          chartResample: resampleValue,
          width: 4
        };
        if (chartEnding) {
          updatePayload.chartEnding = chartEnding;
        }
        if (payload.equipmentClasses && payload.equipmentClasses.length) {
          updatePayload.equipmentClasses = payload.equipmentClasses.slice();
        }
        await loaders.requestWithLoader({
          url: '/api/v1/element/' + ridFragment,
          method: 'PUT',
          body: updatePayload,
          loader: 'background'
        }).catch(function (error) {
          console.error('Failed to persist chart configuration.', error);
        });
        if (typeof ctrl.parentReinitialize === 'function') {
          try {
            await ctrl.parentReinitialize();
          } catch (refreshError) {
            console.error('Unable to refresh parent after saving chart.', refreshError);
          }
        }
        ctrl.setBuilderStatus('Chart saved.', false);
      } catch (error) {
        console.error('Unable to save chart.', error);
        ctrl.setBuilderStatus('Unable to save chart.', true);
      } finally {
        ctrl.builderSaving(false);
        m.redraw();
      }
    };
    ctrl.saveBuilderElement = function () {
      if (!ctrl.isBuilderVariant() || ctrl.builderSaving()) {
        return;
      }
      var elementRecord = ctrl.getElementRecord();
      if (!elementRecord || !elementRecord.parentRid) {
        ctrl.setBuilderStatus('Unable to locate a parent for this Chart.', true);
        return;
      }
      var selectedClasses = ctrl.selectedClasses ? ctrl.selectedClasses() : [];
      if (!Array.isArray(selectedClasses) || selectedClasses.length === 0) {
        ctrl.setBuilderStatus('Select at least one equipment class before saving.', true);
        return;
      }
      var visiblePoints = [];
      var visibleSet = ctrl.visiblePoints && ctrl.visiblePoints();
      if (visibleSet && typeof visibleSet.forEach === 'function') {
        visibleSet.forEach(function (rid) {
          var normalized = ctrl.normalizeRid(rid);
          if (normalized) {
            visiblePoints.push(normalized);
          }
        });
      }
      visiblePoints = Array.from(new Set(visiblePoints));
      if (visiblePoints.length === 0) {
        ctrl.setBuilderStatus('Select at least one point before saving.', true);
        return;
      }
      ctrl.openBuilderNameModal({
        defaultName: '',
        onSubmit: function (name) {
          ctrl.executeBuilderSave({
            elementRecord: elementRecord,
            selectedClasses: selectedClasses.slice(),
            visiblePoints: visiblePoints.slice(),
            chartName: name
          });
        }
      });
    };

    ctrl.normalizeRid = function (rid) {
      if (rid == null) {
        return null;
      }
      if (typeof rid === 'string') {
        return rid;
      }
      if (typeof rid === 'object' && typeof rid.toString === 'function') {
        return rid.toString();
      }
      return String(rid);
    };

    ctrl.normalizeValueField = function (value) {
      var normalized = (value != null ? String(value) : '').trim().toLowerCase();
      if (normalized === 'min' || normalized === 'max' || normalized === 'mean') {
        return normalized;
      }
      return 'mean';
    };

    ctrl.applyDefaultFormValues = function () {
      var elementRecord = typeof ctrl.element === 'function' ? ctrl.element() : ctrl.element;
      if (!elementRecord) {
        return;
      }
      if (ctrl.form.span && (ctrl.form.span() == null || ctrl.form.span() === '')) {
        ctrl.form.span(elementRecord.chartSpan || 8);
      }
      if (ctrl.form.resampling && !ctrl.form.resampling()) {
        ctrl.form.resampling(elementRecord.chartResample || 'hours');
      }
      if (ctrl.form.valueField && !ctrl.form.valueField()) {
        ctrl.form.valueField(ctrl.normalizeValueField(elementRecord.smartChartValueField));
      }
      if (ctrl.form.start && !ctrl.form.start()) {
        var ending = elementRecord.chartEnding;
        if (ending) {
          var endingMoment = moment(ending);
          if (endingMoment.isValid()) {
            ctrl.form.start(endingMoment);
          }
        }
      }
    };

    ctrl.applyDefaultFormValues();

    // C3 instance reference shared across lifecycle callbacks
    ctrl.chart = null;
    // Base chart configuration reused as series data swaps in/out
    ctrl.chartOptions = {
      data: {
        x: 'x',
        columns: [],
      },
      legend: {
        show: false
      },
      grid: {
        x: {
          show: true
        }
      },
      point: {
        show: true,
        r: 1,
      },
      tooltip: {
        show: true,
        grouped: false,
        format: {
          title: function (timestamp) {
            var value = timestamp instanceof Date ? timestamp.getTime() : Number(timestamp);
            if (!Number.isFinite(value)) {
              return '';
            }
            var normalized = value > 1e14 ? Math.floor(value / 1e3) : value;
            var date = moment(normalized);
            return date.isValid() ? date.format(dateFormat) : '';
          }
        }
      },
      axis: {
        y: {
          inner: true,
          tick: {
            count: 4,
            format: function (tick) {
              return parseFloat(tick.toFixed(4).replace(/\.?0+$/, ''));
            }
          },
          padding: { top: 0, bottom: 0 }
        },
        x: {
          type: 'timeseries',
          show: !ctrl.isPointBrowseVariant(),
          tick: {
            fit: false,
            count: 4,
            format: function (value) {
              var numeric = value instanceof Date ? value.getTime() : Number(value);
              if (!Number.isFinite(numeric)) {
                return '';
              }
              var normalized = numeric > 1e14 ? Math.floor(numeric / 1e3) : numeric;
              var date = moment(normalized);
              return date.isValid() ? date.format(dateFormat) : '';
            }
          }
        }
      }
    };
    ctrl.chartOptions.transition = {
      duration: ctrl.chartAnimationDuration
    };

    ctrl.finishActiveChartSlide = function () {
      if (!ctrl.activeSlideCleanup) {
        return;
      }
      var cleanup = ctrl.activeSlideCleanup;
      ctrl.activeSlideCleanup = null;
      cleanup();
    };

    ctrl.captureChartSlide = function (options) {
      if (!options || !ctrl.chartStage || typeof document === 'undefined' || typeof window === 'undefined') {
        return null;
      }
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return null;
      }

      ctrl.finishActiveChartSlide();

      var chartNode = ctrl.chartStage.querySelector('.c3');
      if (!chartNode || typeof chartNode.cloneNode !== 'function') {
        return null;
      }

      var fraction = Number(options.fraction);
      if (!Number.isFinite(fraction) || fraction <= 0) {
        fraction = 0.5;
      }
      fraction = Math.min(1, Math.max(0.01, Math.abs(fraction)));

      var oldLayer = document.createElement('div');
      oldLayer.className = 'smart-chart-slide-layer';
      oldLayer.setAttribute('aria-hidden', 'true');
      oldLayer.style.position = 'absolute';
      oldLayer.style.top = '0';
      oldLayer.style.right = '0';
      oldLayer.style.bottom = '0';
      oldLayer.style.left = '0';
      oldLayer.style.zIndex = '2';
      oldLayer.style.overflow = 'hidden';
      oldLayer.style.pointerEvents = 'none';
      oldLayer.style.backgroundColor = '#212121';
      oldLayer.style.transform = 'translate3d(0, 0, 0)';

      var snapshot = chartNode.cloneNode(true);
      var snapshotSuffix = '-smart-chart-slide-' + (++ctrl.chartSlideSequence);
      var snapshotIds = {};
      var elementsWithIds = snapshot.querySelectorAll('[id]');
      Array.prototype.forEach.call(elementsWithIds, function (element) {
        var originalId = element.getAttribute('id');
        if (!originalId) {
          return;
        }
        snapshotIds[originalId] = originalId + snapshotSuffix;
        element.setAttribute('id', snapshotIds[originalId]);
      });
      Array.prototype.forEach.call(snapshot.querySelectorAll('*'), function (element) {
        Array.prototype.forEach.call(element.attributes || [], function (attribute) {
          var value = attribute.value;
          if (!value || value.indexOf('#') === -1) {
            return;
          }
          var updatedValue = value.replace(/url\(#([^)]+)\)/g, function (match, id) {
            return snapshotIds[id] ? 'url(#' + snapshotIds[id] + ')' : match;
          });
          if (updatedValue.charAt(0) === '#' && snapshotIds[updatedValue.slice(1)]) {
            updatedValue = '#' + snapshotIds[updatedValue.slice(1)];
          }
          if (updatedValue !== value) {
            element.setAttribute(attribute.name, updatedValue);
          }
        });
      });
      snapshot.removeAttribute('id');
      snapshot.style.width = '100%';
      snapshot.style.height = '100%';
      oldLayer.appendChild(snapshot);
      ctrl.chartStage.appendChild(oldLayer);

      return {
        chartNode: chartNode,
        oldLayer: oldLayer,
        direction: options.direction === 'backward' ? 'backward' : 'forward',
        distance: fraction * 100
      };
    };

    ctrl.startChartSlide = function (slide) {
      if (!slide || !slide.chartNode || !slide.oldLayer || typeof window === 'undefined') {
        return;
      }

      var chartNode = slide.chartNode;
      var oldLayer = slide.oldLayer;
      var distance = slide.distance;
      var oldEnd = slide.direction === 'forward' ? -distance : distance;
      var transition = 'transform ' + ctrl.chartAnimationDuration + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
      var timeoutId = null;
      var finished = false;
      var cleanup = function () {
        if (finished) {
          return;
        }
        finished = true;
        if (timeoutId != null) {
          clearTimeout(timeoutId);
        }
        if (oldLayer.parentNode) {
          oldLayer.parentNode.removeChild(oldLayer);
        }
        if (ctrl.chartStage && ctrl.chartStage.classList) {
          ctrl.chartStage.classList.remove('smart-chart-is-sliding');
        }
        if (ctrl.activeSlideCleanup === cleanup) {
          ctrl.activeSlideCleanup = null;
        }
      };

      ctrl.activeSlideCleanup = cleanup;
      if (ctrl.chartStage.classList) {
        ctrl.chartStage.classList.add('smart-chart-is-sliding');
      }
      oldLayer.style.transition = 'none';
      oldLayer.style.willChange = 'transform';

      // Force the starting positions to be committed before the transition.
      oldLayer.getBoundingClientRect();
      var requestFrame = window.requestAnimationFrame || function (callback) { return setTimeout(callback, 0); };
      requestFrame(function () {
        oldLayer.style.transition = transition;
        oldLayer.style.transform = 'translate3d(' + oldEnd + '%, 0, 0)';
        timeoutId = setTimeout(cleanup, ctrl.chartAnimationDuration + 100);
      });
    };

    ctrl.withoutChartTransitions = function (callback) {
      var config = ctrl.chart && ctrl.chart.internal && ctrl.chart.internal.config;
      if (!config) {
        callback();
        return;
      }
      var originalDuration = config.transition_duration;
      config.transition_duration = 0;
      try {
        callback();
        if (ctrl.chart && typeof ctrl.chart.flush === 'function') {
          ctrl.chart.flush();
        }
      } finally {
        config.transition_duration = originalDuration;
      }
    };

    ctrl.applyShiftFlow = function (flowOptions, replacementSeries) {
      if (!flowOptions || !ctrl.chart || typeof ctrl.chart.flow !== 'function') {
        return false;
      }
      if (ctrl.chartStage && ctrl.chartStage.classList) {
        ctrl.chartStage.classList.add('smart-chart-is-sliding');
      }
      var originalDone = flowOptions.done;
      var options = Object.assign({}, flowOptions, {
        duration: ctrl.chartAnimationDuration,
        done: function () {
          if (replacementSeries && replacementSeries.length) {
            ctrl.withoutChartTransitions(function () {
              replacementSeries.forEach(function (entry) {
                ctrl.chart.load({ rows: entry.rows, type: entry.type });
              });
            });
          }
          if (ctrl.chartStage && ctrl.chartStage.classList) {
            ctrl.chartStage.classList.remove('smart-chart-is-sliding');
          }
          if (typeof originalDone === 'function') {
            originalDone();
          }
        }
      });
      try {
        ctrl.chart.flow(options);
        return true;
      } catch (flowError) {
        if (ctrl.chartStage && ctrl.chartStage.classList) {
          ctrl.chartStage.classList.remove('smart-chart-is-sliding');
        }
        console.error('SmartChart flow failed:', flowError);
        return false;
      }
    };

    ctrl.applyChartXDomain = function (domain) {
      if (!domain || !Number.isFinite(domain.min) || !Number.isFinite(domain.max)) {
        return;
      }
      var min = new Date(domain.min);
      var max = new Date(domain.max);
      ctrl.chartOptions.axis.x.min = min;
      ctrl.chartOptions.axis.x.max = max;
      if (ctrl.isPointBrowseVariant()) {
        ctrl.displayXDomain = {
          min: domain.min,
          max: domain.max
        };
      }
      var config = ctrl.chart && ctrl.chart.internal && ctrl.chart.internal.config;
      if (config) {
        config.axis_x_min = min;
        config.axis_x_max = max;
      }
    };

    ctrl.getSeriesYDomain = function (series) {
      var values = [];
      (series || []).forEach(function (entry) {
        if (!entry || !Array.isArray(entry.rows)) {
          return;
        }
        entry.rows.slice(1).forEach(function (row) {
          var value = Array.isArray(row) && row[1] != null ? Number(row[1]) : NaN;
          if (Number.isFinite(value)) {
            values.push(value);
          }
        });
      });
      if (!values.length) {
        return null;
      }
      var min = Math.min.apply(Math, values);
      var max = Math.max.apply(Math, values);
      // Match C3's domain for a constant series. Explicit axis padding is zero.
      if (min === max) {
        if (min < 0) {
          max = 0;
        } else {
          min = 0;
        }
      }
      return { min: min, max: max };
    };

    ctrl.shouldTransitionYAxis = function (domain) {
      var chartInternal = ctrl.chart && ctrl.chart.internal;
      var el = ctrl.getElementRecord();
      var hasFixedBounds = el && (
        (el.yMin != null && String(el.yMin).trim() !== '') ||
        (el.yMax != null && String(el.yMax).trim() !== '')
      );
      if (!domain || hasFixedBounds || !chartInternal || !chartInternal.y ||
          typeof chartInternal.y.domain !== 'function' ||
          !chartInternal.data || !Array.isArray(chartInternal.data.targets) ||
          !chartInternal.data.targets.length) {
        return false;
      }
      var currentDomain = chartInternal.y.domain();
      if (!Array.isArray(currentDomain) || currentDomain.length < 2) {
        return false;
      }
      var currentMin = Number(currentDomain[0]);
      var currentMax = Number(currentDomain[1]);
      if (!Number.isFinite(currentMin) || !Number.isFinite(currentMax)) {
        return false;
      }
      var tolerance = Math.max(Math.abs(currentMax - currentMin) * 0.001, 1e-9);
      return Math.abs(currentMin - domain.min) > tolerance ||
        Math.abs(currentMax - domain.max) > tolerance;
    };

    ctrl.transitionYAxisBeforeShift = function (domain, done) {
      if (!ctrl.shouldTransitionYAxis(domain)) {
        return false;
      }
      var chartInternal = ctrl.chart.internal;
      var config = chartInternal.config;
      if (!config || typeof chartInternal.redraw !== 'function') {
        return false;
      }
      if (ctrl.yAxisTransitionTimeoutId != null) {
        clearTimeout(ctrl.yAxisTransitionTimeoutId);
      }
      var sequence = ++ctrl.yAxisTransitionSequence;
      var originalDuration = config.transition_duration;
      config.axis_y_min = domain.min;
      config.axis_y_max = domain.max;
      config.transition_duration = ctrl.yAxisAnimationDuration;
      chartInternal.redraw({
        withTransition: true,
        withTransitionForAxis: true,
        withUpdateXDomain: false,
        withUpdateOrgXDomain: false,
        withSubchart: false,
        withLegend: false
      });
      config.transition_duration = originalDuration;
      ctrl.yAxisTransitionConfig = config;
      ctrl.yAxisTransitionTimeoutId = setTimeout(function () {
        if (sequence !== ctrl.yAxisTransitionSequence) {
          return;
        }
        ctrl.yAxisTransitionTimeoutId = null;
        ctrl.yAxisTransitionConfig = null;
        // Return control to C3's automatic domain calculation for the new data.
        config.axis_y_min = undefined;
        config.axis_y_max = undefined;
        done();
      }, ctrl.yAxisAnimationDuration + 20);
      return true;
    };

    ctrl.cancelYAxisTransition = function () {
      ctrl.yAxisTransitionSequence += 1;
      if (ctrl.yAxisTransitionTimeoutId != null) {
        clearTimeout(ctrl.yAxisTransitionTimeoutId);
        ctrl.yAxisTransitionTimeoutId = null;
      }
      if (ctrl.yAxisTransitionConfig) {
        ctrl.yAxisTransitionConfig.axis_y_min = ctrl.chartOptions.axis.y.min;
        ctrl.yAxisTransitionConfig.axis_y_max = ctrl.chartOptions.axis.y.max;
        ctrl.yAxisTransitionConfig = null;
      }
    };

    // Apply queued data loads/unloads once the chart instance is ready
    ctrl.applyPendingSeries = function () {
      if (!ctrl.chart) {
        return;
      }

      if (ctrl.yAxisTransitionTimeoutId != null &&
          (ctrl.pendingSeries.length || ctrl.pendingSlide || ctrl.pendingShiftFlow)) {
        ctrl.cancelYAxisTransition();
      }

      var pendingSlide = ctrl.pendingSlide;
      ctrl.pendingSlide = null;
      var pendingShiftFlow = ctrl.pendingShiftFlow;
      ctrl.pendingShiftFlow = null;
      var pendingXDomain = ctrl.pendingXDomain;
      ctrl.pendingXDomain = null;

      var series = ctrl.pendingSeries.slice();
      var shouldClear = ctrl.pendingSeriesClear;
      ctrl.pendingSeries = [];
      ctrl.pendingSeriesClear = false;

      if (!series.length && !pendingShiftFlow) {
        if (shouldClear) {
          try {
            ctrl.chart.unload();
          } catch (e) {
            // ignore unload errors
          }
        }
        return;
      }

      var applySeriesUpdate = function () {
        var slide = pendingSlide ? ctrl.captureChartSlide(pendingSlide) : null;
        ctrl.applyChartXDomain(pendingXDomain);

        if (pendingShiftFlow && ctrl.applyShiftFlow(pendingShiftFlow, series)) {
          return;
        }

        var targetIds = new Set();
        series.forEach(function (entry) {
          if (!entry || !Array.isArray(entry.rows) || entry.rows.length === 0) {
            return;
          }
          var header = entry.rows[0];
          if (Array.isArray(header) && header.length > 1 && header[1]) {
            targetIds.add(header[1]);
          }
        });

        var unloadIds;
        if (shouldClear) {
          unloadIds = true;
        } else if (ctrl.chart && typeof ctrl.chart.data === 'function') {
          unloadIds = ctrl.chart.data().map(function (dataset) {
            return dataset && dataset.id;
          }).filter(function (id) {
            return id && !targetIds.has(id);
          });
          if (Array.isArray(unloadIds) && !unloadIds.length) {
            unloadIds = undefined;
          }
        }

        var loadSeries = function () {
          series.forEach(function (entry, idx) {
            var loadOptions = {
              rows: entry.rows,
              type: entry.type
            };
            if (idx === 0 && unloadIds !== undefined) {
              loadOptions.unload = unloadIds;
            }
            ctrl.chart.load(loadOptions);
          });
        };

        if (slide) {
          ctrl.withoutChartTransitions(loadSeries);
          ctrl.startChartSlide(slide);
        } else {
          loadSeries();
          if (pendingXDomain && ctrl.chart && typeof ctrl.chart.flush === 'function') {
            ctrl.chart.flush();
          }
        }
      };

      var isRangeShift = Boolean(pendingSlide || pendingShiftFlow);
      var nextYDomain = isRangeShift ? ctrl.getSeriesYDomain(series) : null;
      if (isRangeShift && ctrl.transitionYAxisBeforeShift(nextYDomain, applySeriesUpdate)) {
        return;
      }
      applySeriesUpdate();
    };

    ctrl.normalizeTimestamp = function (value) {
      var numeric = Number(value);
      if (!Number.isFinite(numeric)) {
        return null;
      }
      return numeric > 1e14 ? Math.floor(numeric / 1e3) : numeric;
    };

    ctrl.formatPointBrowseRangeTimestamp = function (value) {
      var normalized = ctrl.normalizeTimestamp(value);
      if (normalized == null) {
        return '';
      }
      var date = moment(normalized);
      return date.isValid() ? date.format('MM/DD/YY h:mm A') : '';
    };

    ctrl.renderPointBrowseRangeLabels = function () {
      var domain = ctrl.displayXDomain;
      if (!ctrl.isPointBrowseVariant() || !domain) {
        return null;
      }
      return m('div.smart-chart-range-labels.flex.justify-between.mt2.f5', [
        m('div.smart-chart-range-start.tl', [
          m('div.mid-gray.f6', 'Start'),
          m('div', ctrl.formatPointBrowseRangeTimestamp(domain.min))
        ]),
        m('div.smart-chart-range-end.tr', [
          m('div.mid-gray.f6', 'Ending'),
          m('div', ctrl.formatPointBrowseRangeTimestamp(domain.max))
        ])
      ]);
    };

    ctrl.csvEscape = function (value) {
      if (value == null) {
        return '';
      }
      var str = String(value);
      if (/["\n,]/.test(str)) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    };

    ctrl.downloadCsv = function (content, fileName) {
      if (typeof document === 'undefined') {
        return;
      }
      var link = document.createElement('a');
      var blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(function () {
        URL.revokeObjectURL(link.href);
      }, 0);
    };

    ctrl.exportVisibleData = function (event) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      var visibleRids = Array.from(ctrl.visiblePoints()).filter(function (rid) {
        return ctrl.pointsMeta.has(rid);
      });
      if (!visibleRids.length || !ctrl.latestSeriesData.size) {
        return;
      }

      var headers = [
        'timestamp_iso',
        'timestamp',
        'value',
        'series',
        'point_name',
        'dataset',
        'equipment',
        'statistic',
        'unit'
      ];
      var lines = [headers.map(ctrl.csvEscape).join(',')];

      visibleRids.forEach(function (rid) {
        var meta = ctrl.pointsMeta.get(rid);
        var seriesData = ctrl.latestSeriesData.get(rid);
        if (!meta || !seriesData || !Array.isArray(seriesData.rows)) {
          return;
        }
        seriesData.rows.forEach(function (row) {
          var normalizedTs = ctrl.normalizeTimestamp(row[0]);
          if (normalizedTs == null) {
            return;
          }
          var isoTimestamp = moment(normalizedTs).toISOString();
          var rowData = [
            isoTimestamp,
            normalizedTs,
            row[1],
            meta.seriesLabel,
            meta.point && meta.point.name ? meta.point.name : '',
            meta.datasetName || '',
            meta.equipmentLabel || '',
            seriesData.statistic || ctrl.lastRequestedField || '',
            meta.unitLabel || ''
          ];
          lines.push(rowData.map(ctrl.csvEscape).join(','));
        });
      });

      if (lines.length <= 1) {
        return;
      }

      var el = typeof ctrl.element === 'function' ? ctrl.element() : null;
      var fileName = (el && el.name ? el.name.replace(/\s+/g, '_').toLowerCase() : 'smart_chart') + '_data.csv';
      ctrl.downloadCsv(lines.join('\n'), fileName);
    };

    // Restore the persisted visible points configuration from the element
    ctrl.loadConfiguration = function () {
      if (ctrl.isBuilderVariant()) {
        ctrl.visiblePoints(new Set());
        return;
      }
      var el = ctrl.element();
      var hiddenFields = el.hiddenFields || {};
      var config = hiddenFields.smartChartConfig || {};
      var visible = Array.isArray(config.visiblePoints) ? config.visiblePoints : [];
      var normalized = [];
      visible.forEach(function (rid) {
        var normalizedRid = ctrl.normalizeRid(rid);
        if (normalizedRid && ctrl.pointsMeta.has(normalizedRid)) {
          normalized.push(normalizedRid);
        }
      });
      ctrl.visiblePoints(new Set(normalized));
    };

    // Persist the current visibility selection back onto the element record
    ctrl.saveVisiblePoints = async function (skipRedraw) {
      if (ctrl.isBuilderVariant()) {
        if (!skipRedraw) { m.redraw(); }
        return;
      }
      var el = ctrl.element();
      var hiddenFields = el.hiddenFields ? Object.assign({}, el.hiddenFields) : {};
      hiddenFields.smartChartConfig = hiddenFields.smartChartConfig || {};
      hiddenFields.smartChartConfig.visiblePoints = Array.from(ctrl.visiblePoints());
      el.hiddenFields = hiddenFields;
      if (!el['@rid']) {
        if (!skipRedraw) { m.redraw(); }
        return;
      }
      try {
        await loaders.requestWithLoader({
          url: '/api/v1/element/' + el['@rid'].slice(1),
          method: 'PUT',
          body: { hiddenFields: hiddenFields },
          background: true,
          loader: 'background'
        });
      } catch (err) {
        ctrl.error('Unable to save chart configuration.');
      } finally {
        if (!skipRedraw) { m.redraw(); }
      }
    };

    // Fetch the latest series data for all visible points and queue it for the chart
    ctrl.refreshChartData = async function (options) {
      options = options || {};
      var isShift = options.type === 'shift';
      var shiftDirection = isShift ? options.direction : null;
      if (edit.vm.editing()) {
        ctrl.pendingSeries = [];
        ctrl.pendingSeriesClear = true;
        ctrl.applyPendingSeries();
        return;
      }
      var requestId = ++ctrl.refreshSequence;
      ctrl.latestRefreshRequestId = requestId;
      ctrl.pendingSlide = null;
      ctrl.pendingShiftFlow = null;
      ctrl.pendingXDomain = null;
      ctrl.cancelYAxisTransition();
      var showLoader = !isShift;
      if (showLoader) {
        ctrl.chartRefreshing(true);
        m.redraw();
      }
      ctrl.pendingSeries = [];
      ctrl.pendingSeriesClear = !isShift;
      try {
        var el = ctrl.element();
        var span = parseFloat(ctrl.form.span && ctrl.form.span());
        if (!Number.isFinite(span) || span <= 0) {
          span = el.chartSpan || 8;
        }
        var resample = (ctrl.form.resampling && ctrl.form.resampling()) || el.chartResample || 'hours';
        var visibleSet = ctrl.visiblePoints();
        var visibleRids = Array.from(visibleSet).filter(function (rid) { return ctrl.pointsMeta.has(rid); });

        ctrl.chartOptions.axis.y.max = el.yMax ? parseFloat(el.yMax) : undefined;
        ctrl.chartOptions.axis.y.min = el.yMin ? parseFloat(el.yMin) : undefined;

        if (!visibleRids.length) {
          ctrl.pendingSeries = [];
          ctrl.pendingSeriesClear = true;
          ctrl.applyPendingSeries();
          m.redraw();
          return;
        }

        var startValue = ctrl.form.start && ctrl.form.start();
        var startMoment = startValue ? moment(startValue) : moment();
        if (!startMoment.isValid()) {
          startMoment = moment();
        }
        var startTime = startMoment.valueOf();
        var unitForSpan = ctrl.resolveSpanUnit(resample);
        var normalizedUnit = unitForSpan === 'hour' ? 'hours' : unitForSpan;
        var spanDuration = moment.duration(span, normalizedUnit);
        var spanMs = spanDuration && typeof spanDuration.asMilliseconds === 'function' ? spanDuration.asMilliseconds() : 0;
        if (!Number.isFinite(spanMs) || spanMs <= 0) {
          spanMs = 0;
        }
        var requestRids = visibleRids.map(function (rid) {
          return rid && rid.charAt(0) === '#' ? rid.slice(1) : rid;
        });
        var requestPayload = {
          rids: requestRids,
          start: startTime,
          span: span,
          resample: resample
        };
        var batchResponse;
        if (ctrl.isPointBrowseVariant() && requestRids.length === 1) {
          var singlePointResponse = await loaders.requestWithLoader({
            url: '/api/v1/data/' + requestRids[0],
            method: 'GET',
            params: {
              start: requestPayload.start,
              span: requestPayload.span,
              resample: requestPayload.resample
            },
            background: true,
            loader: 'background'
          }).catch(function (error) {
            console.error('Failed to load point timeseries:', error);
            return null;
          });
          batchResponse = { results: {} };
          batchResponse.results[requestRids[0]] = singlePointResponse;
        } else {
          batchResponse = await loaders.requestWithLoader({
            url: '/api/v1/data/batch',
            method: 'POST',
            body: requestPayload,
            background: true,
            loader: 'background'
          }).catch(function (error) {
            console.error('Failed to load batch timeseries:', error);
            return null;
          });
        }
        if (requestId !== ctrl.latestRefreshRequestId) {
          return;
        }
        if (!batchResponse || typeof batchResponse !== 'object') {
          return;
        }
        var seriesByRid = batchResponse.results || {};
        var series = [];
        var rawValueField = ctrl.form.valueField ? ctrl.form.valueField() : null;
        if (!rawValueField && el.smartChartValueField != null) {
          rawValueField = el.smartChartValueField;
        }
        var requestedField = ctrl.normalizeValueField(rawValueField);
        if (ctrl.form.valueField && ctrl.form.valueField() !== requestedField) {
          ctrl.form.valueField(requestedField);
        }
        if (el) {
          el.smartChartValueField = requestedField;
        }
        ctrl.lastRequestedField = requestedField;
        ctrl.latestSeriesData.clear();
        var visibleRidSet = new Set(visibleRids);
        ctrl.seriesCache.forEach(function (_, key) {
          if (!visibleRidSet.has(key)) {
            ctrl.seriesCache.delete(key);
          }
        });
        var previousSeriesCache = new Map();
        var chartTimestampMultiplier = 1;
        if (isShift) {
          visibleRids.forEach(function (rid) {
            var cached = ctrl.seriesCache.get(rid);
            previousSeriesCache.set(rid, cached ? cached.slice() : []);
            var cachedTimestamp = Number(cached && cached[0] && cached[0][0]);
            if (Number.isFinite(cachedTimestamp) && Math.abs(cachedTimestamp) > 1e14) {
              chartTimestampMultiplier = 1000;
            }
          });
        }
        var hasDirectionalData = false;
        var seriesRids = new Set();
        visibleRids.forEach(function (rid, idx) {
          var requestKey = requestRids[idx];
          var response = seriesByRid && requestKey != null ? seriesByRid[requestKey] : null;
          if (!response || !response.data) {
            return;
          }
          var meta = ctrl.pointsMeta.get(rid);
          if (!meta) {
            return;
          }
          var ts = response.data;
          var exportRows = [];
          var pointRecord = meta.point;
          var columnNames = Array.isArray(ts.columns) ? ts.columns : null;
          var fieldIndex = columnNames ? columnNames.indexOf(requestedField) : -1;
          if (fieldIndex < 0 && Array.isArray(ts.values) && ts.values.length) {
            var headerRow = ts.values[0];
            if (Array.isArray(headerRow)) {
              var headerIndex = headerRow.indexOf(requestedField);
              if (headerIndex > -1) {
                fieldIndex = headerIndex;
              }
            }
          }
          if (fieldIndex < 1) {
            fieldIndex = 1;
          }
          (ts.values || []).forEach(function (row) {
            if (!Array.isArray(row) || row.length <= fieldIndex) { return; }
            var timestamp = Number(row[0]);
            if (Number.isNaN(timestamp)) { return; }
            if (Math.abs(timestamp) > 1e14) {
              chartTimestampMultiplier = 1000;
            }
            var rawValue = row[fieldIndex];
            if (rawValue == null) { return; }
            var numericValue = typeof rawValue === 'number' ? rawValue : Number(rawValue);
            if (!Number.isFinite(numericValue)) { return; }
            exportRows.push([
              timestamp,
              Point.readValue({
                value: numericValue,
                unit: pointRecord.unit,
                destUnit: pointRecord.destUnit,
                displayUnit: pointRecord.displayUnit
              }, true)
            ]);
          });
          if (!exportRows.length) {
            return;
          }
          if (isShift) {
            var previousRows = previousSeriesCache.get(rid) || [];
            if (previousRows.length) {
              var previousFirst = previousRows[0] && Number(previousRows[0][0]);
              var previousLast = previousRows[previousRows.length - 1] && Number(previousRows[previousRows.length - 1][0]);
              hasDirectionalData = hasDirectionalData || exportRows.some(function (row) {
                var timestamp = Number(row && row[0]);
                return shiftDirection === 'forward'
                  ? Number.isFinite(previousLast) && timestamp > previousLast
                  : Number.isFinite(previousFirst) && timestamp < previousFirst;
              });
            } else {
              hasDirectionalData = true;
            }
          }
          ctrl.latestSeriesData.set(rid, {
            rows: exportRows.slice(),
            statistic: requestedField
          });
          ctrl.seriesCache.set(rid, exportRows.slice());
          var chartRows = exportRows.map(function (entry) {
            return [entry[0], entry[1]];
          });
          chartRows.unshift(['x', meta.seriesLabel]);
          series.push({
            rid: rid,
            rows: chartRows,
            type: meta.chartType || 'line'
          });
          seriesRids.add(rid);
        });

        var chartRangeStart = (startTime - spanMs) * chartTimestampMultiplier;
        var chartRangeEnd = startTime * chartTimestampMultiplier;
        ctrl.pendingXDomain = {
          min: chartRangeStart,
          max: chartRangeEnd
        };
        visibleRids.forEach(function (rid) {
          if (seriesRids.has(rid)) {
            return;
          }
          var meta = ctrl.pointsMeta.get(rid);
          if (!meta) {
            return;
          }
          ctrl.seriesCache.set(rid, []);
          series.push({
            rid: rid,
            rows: [
              ['x', meta.seriesLabel],
              [chartRangeStart, null],
              [chartRangeEnd, null]
            ],
            type: meta.chartType || 'line'
          });
          seriesRids.add(rid);
        });

        ctrl.pendingSeries = series;
        var canUseForwardFlow = isShift && shiftDirection === 'forward' && !hasDirectionalData && previousSeriesCache.size;
        if (canUseForwardFlow) {
          var flowEnd = chartRangeEnd;
          var flowStart = chartRangeStart;
          var flowColumns = [['x', flowEnd]];
          visibleRids.forEach(function (rid) {
            var meta = ctrl.pointsMeta.get(rid);
            if (meta && meta.seriesLabel) {
              flowColumns.push([meta.seriesLabel, null]);
            }
          });
          if (flowColumns.length > 1) {
            ctrl.pendingShiftFlow = {
              columns: flowColumns,
              to: flowStart
            };
          }
        }
        ctrl.pendingSlide = isShift && !ctrl.pendingShiftFlow && series.length ? {
          direction: shiftDirection,
          fraction: options.fraction
        } : null;
        ctrl.pendingSeriesClear = !series.length && !isShift;
        ctrl.applyPendingSeries();
      } finally {
        if (showLoader && ctrl.latestRefreshRequestId === requestId && ctrl.chartRefreshing && ctrl.chartRefreshing()) {
          ctrl.chartRefreshing(false);
          m.redraw();
        } else if (!showLoader && ctrl.latestRefreshRequestId === requestId) {
          m.redraw();
        }
      }
    };

    // Toggle visibility for a single logical point (and its grouped peers) across datasets
    ctrl.togglePointVisibility = async function (dataset, pointName) {
      if (!dataset || !pointName) {
        return;
      }
      var relatedDatasets = ctrl.datasets().filter(function (item) {
        return item.groupKey === dataset.groupKey;
      });
      if (!relatedDatasets.length) {
        relatedDatasets = [dataset];
      }
      var targetRids = new Set();
      relatedDatasets.forEach(function (ds) {
        (ds.points || []).forEach(function (point) {
          if (point.pointRid && point.name === pointName) {
            var normalizedRid = ctrl.normalizeRid(point.pointRid);
            if (normalizedRid && ctrl.pointsMeta.has(normalizedRid)) {
              targetRids.add(normalizedRid);
            }
          }
        });
      });
      if (!targetRids.size) { return; }
      var set = new Set();
      var currentVisible = ctrl.visiblePoints();
      if (currentVisible && typeof currentVisible.forEach === 'function') {
        currentVisible.forEach(function (rid) {
          var normalized = ctrl.normalizeRid(rid);
          if (normalized && ctrl.pointsMeta.has(normalized)) {
            set.add(normalized);
          }
        });
      }
      var allVisible = Array.from(targetRids).every(function (rid) { return set.has(rid); });
      targetRids.forEach(function (rid) {
        if (allVisible) {
          set.delete(rid);
        } else {
          set.add(rid);
        }
      });
      ctrl.visiblePoints(set);
      await ctrl.saveVisiblePoints(true);
      if (edit.vm.editing()) {
        ctrl.pendingSeries = [];
        ctrl.pendingSeriesClear = true;
        ctrl.applyPendingSeries();
        m.redraw();
        return;
      }
      await ctrl.refreshChartData();
      m.redraw();
    };

    // Toggle all points belonging to a dataset (and grouped duplicates) in one action
    ctrl.toggleDatasetVisibility = async function (dataset) {
      if (!dataset || !Array.isArray(dataset.points)) {
        return;
      }
      var relatedDatasets = ctrl.datasets().filter(function (item) {
        return item.groupKey === dataset.groupKey;
      });
      if (!relatedDatasets.length) {
        relatedDatasets = [dataset];
      }
      var set = new Set();
      var currentVisible = ctrl.visiblePoints();
      if (currentVisible && typeof currentVisible.forEach === 'function') {
        currentVisible.forEach(function (rid) {
          var normalized = ctrl.normalizeRid(rid);
          if (normalized && ctrl.pointsMeta.has(normalized)) {
            set.add(normalized);
          }
        });
      }
      var targetRids = new Set();
      relatedDatasets.forEach(function (ds) {
        (ds.points || []).forEach(function (point) {
          if (point && point.pointRid) {
            var normalizedRid = ctrl.normalizeRid(point.pointRid);
            if (normalizedRid && ctrl.pointsMeta.has(normalizedRid)) {
              targetRids.add(normalizedRid);
            }
          }
        });
      });
      if (!targetRids.size) { return; }
      var allVisible = Array.from(targetRids).every(function (rid) { return set.has(rid); });
      targetRids.forEach(function (rid) {
        if (allVisible) {
          set.delete(rid);
        } else {
          set.add(rid);
        }
      });
      ctrl.visiblePoints(set);
      await ctrl.saveVisiblePoints(true);
      if (edit.vm.editing()) {
        ctrl.pendingSeries = [];
        ctrl.pendingSeriesClear = true;
        ctrl.applyPendingSeries();
        m.redraw();
        return;
      }
      await ctrl.refreshChartData();
      m.redraw();
    };

    // Build the list of metadata records for currently visible points
    ctrl.getLegendPointRecords = function () {
      var visible = ctrl.visiblePoints();
      if (!visible || !visible.size) {
        return [];
      }
      var records = [];
      visible.forEach(function (rid) {
        var meta = ctrl.pointsMeta.get(rid);
        if (meta) {
          records.push(meta);
        }
      });
      return records;
    };

    // Render a custom legend that mirrors point visibility and supports toggling series
    ctrl.renderPointLegends = function () {
      if (ctrl.isPointBrowseVariant()) {
        return null;
      }
      var pointRecords = ctrl.getLegendPointRecords();
      if (!pointRecords.length && !ctrl.isBuilderVariant()) {
        return null;
      }
      var colorMap = (ctrl.chart && ctrl.chart.data && typeof ctrl.chart.data.colors === 'function')
        ? ctrl.chart.data.colors()
        : {};
      var naturalCompare = function (lhs, rhs) {
        var tokenize = function (value) {
          if (value == null) { return ['']; }
          return value.toString().toLowerCase().split(/(\d+)/).filter(function (segment) {
            return segment !== '';
          });
        };
        var aTokens = tokenize(lhs);
        var bTokens = tokenize(rhs);
        var maxLen = Math.max(aTokens.length, bTokens.length);
        for (var i = 0; i < maxLen; i++) {
          var aToken = aTokens[i] || '';
          var bToken = bTokens[i] || '';
          var aIsNum = /^\d+$/.test(aToken);
          var bIsNum = /^\d+$/.test(bToken);
          if (aIsNum && bIsNum) {
            var aNum = parseInt(aToken, 10);
            var bNum = parseInt(bToken, 10);
            if (aNum !== bNum) {
              return aNum - bNum;
            }
          } else {
            if (aToken < bToken) { return -1; }
            if (aToken > bToken) { return 1; }
          }
        }
        return 0;
      };
      var sortedRecords = pointRecords.slice().sort(function (a, b) {
        var labelA = (a && a.seriesLabel) ? a.seriesLabel : '';
        var labelB = (b && b.seriesLabel) ? b.seriesLabel : '';
        return naturalCompare(labelA, labelB);
      });
      var isEditing = edit.vm.editing();
      if (isEditing && typeof ctrl.legendCollapsed === 'function' && ctrl.legendCollapsed()) {
        ctrl.legendCollapsed(false);
      }
      var legendCollapsed = (typeof ctrl.legendCollapsed === 'function') ? ctrl.legendCollapsed() : false;
      var toggleLegendCollapse = function (event) {
        if (event) {
          event.stopPropagation();
          event.preventDefault();
        }
        if (typeof ctrl.legendCollapsed === 'function') {
          ctrl.legendCollapsed(!legendCollapsed);
          m.redraw();
        }
      };
      var handleLegendKeyToggle = function (event) {
        if (!event) { return; }
        var key = event.key || event.code;
        if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
          event.preventDefault();
          toggleLegendCollapse(event);
        }
      };

      var legendItems = sortedRecords.map(function (record) {
        var seriesLabel = record.seriesLabel;
        var equipmentClass = record.equipmentClass;
        var equipmentRid = record.equipmentRid;
        var color = colorMap[seriesLabel] || '';
        var isShown = true;
        if (ctrl.chart && ctrl.chart.data && typeof ctrl.chart.data.shown === 'function') {
          var shownData = ctrl.chart.data.shown(seriesLabel);
          isShown = !(Array.isArray(shownData) && shownData.length === 0);
        }
        var labelClasses = 'f5 truncate-ns';
        if (!isShown) {
          labelClasses += ' gray';
        }
    
        return m('div.w-auto.flex.justify-center.items-center.ph2.ba.b--dotted.bw1.mv1.legend-item', {
          key: record.key || seriesLabel,
          'data-series-label': seriesLabel,
          onmouseenter: function () {
            if (ctrl.chart && typeof ctrl.chart.focus === 'function') {
              ctrl.chart.focus(seriesLabel);
            }
            var chart = ctrl.chart;
            var hasDataFn = chart && typeof chart.data === 'function';
            var hasShownFn = hasDataFn && chart.data && typeof chart.data.shown === 'function';
            var seriesIds = [];
            var allSeriesShown = false;
            if (hasDataFn && hasShownFn) {
              var datasets = chart.data();
              if (Array.isArray(datasets)) {
                seriesIds = datasets.map(function (dataset) {
                  return dataset && dataset.id;
                }).filter(function (id) { return !!id; });
              }
              var shownList = chart.data.shown();
              var totalShown = Array.isArray(shownList) ? shownList.length : 0;
              allSeriesShown = seriesIds.length > 0 && totalShown === seriesIds.length;
            }
            // Adjust other legend labels to highlight the hovered series
            document.querySelectorAll('.legend-item').forEach(function (item) {
              if (!item) { return; }
              if (item === this) {
                item.classList.remove('gray');
                var labelEl = item.querySelector('label');
                if (labelEl) {
                  labelEl.classList.remove('gray');
                }
                return;
              }
              if (!hasDataFn || !hasShownFn) {
                item.classList.remove('gray');
                var fallbackLabel = item.querySelector('label');
                if (fallbackLabel) {
                  fallbackLabel.classList.remove('gray');
                }
                return;
              }
              var itemSeries = item.getAttribute('data-series-label');
              if (!itemSeries) {
                item.classList.remove('gray');
                var missingLabel = item.querySelector('label');
                if (missingLabel) {
                  missingLabel.classList.remove('gray');
                }
                return;
              }

              if (allSeriesShown) {
                item.classList.add('gray');
                var allLabel = item.querySelector('label');
                if (allLabel) {
                  allLabel.classList.add('gray');
                }
                return;
              }

              var itemShown = chart.data.shown(itemSeries);
              var isItemShown = Array.isArray(itemShown) && itemShown.length > 0;
              var labelEl = item.querySelector('label');
              if (isItemShown) {
                item.classList.remove('gray');
                if (labelEl) {
                  labelEl.classList.remove('gray');
                }
              } else {
                item.classList.add('gray');
                if (labelEl) {
                  labelEl.classList.add('gray');
                }
              }
            }, this);
          },
          onmouseleave: function () {
            if (ctrl.chart && typeof ctrl.chart.revert === 'function') {
              ctrl.chart.revert('');
            }
            var chart = ctrl.chart;
            var hasDataFn = chart && typeof chart.data === 'function';
            var hasShownFn = hasDataFn && chart.data && typeof chart.data.shown === 'function';
            // Restore legend styles based on current series visibility
            document.querySelectorAll('.legend-item').forEach(function (item) {
              if (!item) { return; }
              var labelEl = item.querySelector('label');
              if (!hasDataFn || !hasShownFn) {
                item.classList.remove('gray');
                if (labelEl) { labelEl.classList.remove('gray'); }
                return;
              }
              var itemSeries = item.getAttribute('data-series-label');
              if (!itemSeries) {
                item.classList.remove('gray');
                if (labelEl) { labelEl.classList.remove('gray'); }
                return;
              }
              var itemShown = chart.data.shown(itemSeries);
              var isItemShown = Array.isArray(itemShown) && itemShown.length > 0;
              if (isItemShown) {
                item.classList.remove('gray');
                if (labelEl) { labelEl.classList.remove('gray'); }
              } else {
                item.classList.add('gray');
                if (labelEl) { labelEl.classList.add('gray'); }
              }
            });
          },
          onclick: function () {
            if (!ctrl.chart || typeof ctrl.chart.data !== 'function' || typeof ctrl.chart.data.shown !== 'function') {
              return;
            }

            var dataSets = ctrl.chart.data();
            if (!Array.isArray(dataSets) || !dataSets.length) {
              return;
            }

            var allSeries = dataSets.map(function (dataset) {
              return dataset && dataset.id;
            }).filter(function (id) {
              return !!id;
            });
            if (!allSeries.length) {
              return;
            }

            var shownTargets = ctrl.chart.data.shown();
            var totalShownBefore = Array.isArray(shownTargets) ? shownTargets.length : 0;
            var shown = ctrl.chart.data.shown(seriesLabel);
            var isShown = Array.isArray(shown) && shown.length > 0;

            if (totalShownBefore === allSeries.length && isShown) {
              var others = allSeries.filter(function (id) {
                return id !== seriesLabel;
              });
              if (others.length && typeof ctrl.chart.hide === 'function') {
                ctrl.chart.hide(others);
              }
              if (typeof ctrl.chart.show === 'function') {
                ctrl.chart.show(seriesLabel);
              }
              return;
            }

            if (!isShown) {
              if (typeof ctrl.chart.show === 'function') {
                ctrl.chart.show(seriesLabel);
              }
              return;
            }

            if (totalShownBefore <= 1) {
              if (typeof ctrl.chart.show === 'function') {
                ctrl.chart.show(allSeries);
              }
              return;
            }

            if (typeof ctrl.chart.hide === 'function') {
              ctrl.chart.hide(seriesLabel);
            }
          }
        }, [
          m('label', {
            class: labelClasses,
            onclick: isEditing ? function (event) {
              event.stopPropagation();
              event.preventDefault();
            } : undefined
          }, (function () {
            if (isEditing || !equipmentRid || !equipmentClass) {
              return seriesLabel;
            }
            var equipmentId = equipmentRid.toString().charAt(0) === '#' ? equipmentRid.toString().slice(1) : equipmentRid;
            if (!equipmentId) {
              return seriesLabel;
            }
            var equipmentLabel = record.equipmentLabel;
            if (!equipmentLabel) {
              return seriesLabel;
            }
            var datasetName = record.datasetName;
            var pointName = record.name;
            var unitLabel = record.unitLabel;
            var remainingLabel = '';
            if (datasetName && datasetName !== 'Default') {
              remainingLabel += ' – ' + datasetName;
            }
            remainingLabel += ' – ' + pointName + (unitLabel ? ' (' + unitLabel + ')' : '');
            var routePath = '/equipment/' + equipmentClass + '/' + equipmentId;
            return [
              m('a', {
                href: routePath,
                class: 'blue underline-hover pointer',
                onclick: function (event) {
                  event.stopPropagation();
                  event.preventDefault();
                  m.route.set(routePath);
                }
              }, equipmentLabel),
              remainingLabel
            ];
          })()),
          m('i.ion-record.ml2', { style: { color } })
        ]);
      });
      var headerLabel = 'Legend (' + sortedRecords.length + ')';
      var legendToggle = m('div.flex.items-center.pointer', {
        role: 'button',
        tabindex: 0,
        'aria-expanded': legendCollapsed ? 'false' : 'true',
        onclick: toggleLegendCollapse,
        onkeypress: handleLegendKeyToggle
      }, [
        m('span.f5', headerLabel),
        m('i.f3.' + (legendCollapsed ? 'ion-chevron-down' : 'ion-close') + '.ml2.blue')
      ]);
      var headerLeft = ctrl.isBuilderVariant() ? m('div.flex.flex-column.mr3', [
        ctrl.renderClassSelector(),
        ctrl.renderPointSelector({
          label: 'Points',
          placeholderValue: 'Select points',
          keyPrefix: 'builder-point-selector',
          className: 'mt3',
          emptyMessage: 'No points match the selected classes.'
        })
      ]) : m('div');
      var header = m('div.flex.flex-wrap.items-start.mb2.justify-between', [
        headerLeft,
        legendToggle
      ]);
      var legendBody;
      if (legendCollapsed) {
        legendBody = null;
      } else if (sortedRecords.length) {
        legendBody = m('div.flex.flex-wrap.justify-between', legendItems);
      } else if (ctrl.isBuilderVariant()) {
        legendBody = m('div.mid-gray.mv2', 'Select points to populate the legend.');
      } else {
        legendBody = null;
      }
      return m('div.mt1', [
        header,
        legendBody
      ]);
    };

    ctrl.normalizeDatasets = function (equipmentRecords) {
      ctrl.pointsMeta.clear();
      var datasets = [];
      var list = Array.isArray(equipmentRecords) ? equipmentRecords : [equipmentRecords];
      list.forEach(function (equipmentRecord, eqIdx) {
        if (!equipmentRecord) { return; }
        var equipmentRid = equipmentRecord['@rid'];
        var equipmentLabel = equipmentRecord.name || equipmentRecord['@class'] || ('Equipment ' + (eqIdx + 1));
        var equipmentKey = equipmentRid || ('equipment-' + eqIdx);

        (equipmentRecord.out_Contains || []).forEach(function (edge, idx) {
          if (!edge || !edge.in) { return; }
          var dataset = edge.in;
          if (dataset.type === 'spacer') { return; }
          var templateRef = dataset.templateRid || dataset.datasetTemplateRid || dataset.templateKey || dataset.template || dataset.datasetTemplate || dataset.templateName;
          var groupKey = templateRef || ((dataset['@class'] || 'Dataset') + '::' + (dataset.name || 'Dataset'));
          var datasetKey = (dataset['@rid'] || ('dataset-' + eqIdx + '-' + idx)) + '::' + equipmentKey;
          var datasetName = dataset.name || dataset['@class'] || 'Dataset';
          if (dataset.type === 'spacer') { return; }
          var points = [];

          (dataset.out_Column || []).forEach(function (columnEdge, cIdx) {
            if (!columnEdge) { return; }
            var point = columnEdge.in || {};
            var pointRid = ctrl.normalizeRid(point['@rid']);
            var columnName = columnEdge.name || point.name || ('Point ' + (cIdx + 1));
            var unitLabel = Point.formatUnit(point);
            var datasetLabelPart = (datasetName && datasetName !== 'Default') ? ' – ' + datasetName : '';
            var seriesLabel = equipmentLabel + datasetLabelPart + ' – ' + columnName + (unitLabel ? ' (' + unitLabel + ')' : '');
            var pathKey = (groupKey || (datasetName || 'Dataset')) + '::' + columnName;
            var record = {
              key: columnEdge['@rid'] || (datasetKey + '::' + columnName + '::' + cIdx),
              name: columnName,
              pointRid: pointRid,
              unitLabel: unitLabel,
              datasetName: datasetName,
              chartType: columnEdge.chartType || 'line',
              point: point,
              seriesLabel: seriesLabel,
              equipmentLabel: equipmentLabel,
              equipmentRid: equipmentRid,
              equipmentClass: equipmentRecord && equipmentRecord['@class'],
              groupKey: groupKey,
              pathKey: pathKey
            };

            if (pointRid) {
              ctrl.pointsMeta.set(pointRid, record);
              ctrl.ridToPathKey.set(pointRid, pathKey);
              points.push(record);
            } else {
              points.push(Object.assign({}, record, { disabled: true }));
            }
          });

          datasets.push({
            key: datasetKey,
            name: datasetName,
            displayName: datasetName,
            equipmentLabel: equipmentLabel,
            equipmentRid: equipmentRid,
            equipmentClass: equipmentRecord && equipmentRecord['@class'],
            groupKey: groupKey,
            points: points
          });
        });
      });
      ctrl.datasets(datasets);
      ctrl.loadConfiguration();
    };

    ctrl.normalizeFieldDiscovery = function (fieldDiscovery) {
      ctrl.pointsMeta.clear();
      var datasets = classPointSelection.normalizeFieldDiscovery(fieldDiscovery, Point.formatUnit);
      datasets.forEach(function (dataset) {
        (dataset.points || []).forEach(function (point) {
          if (point.pointRid) {
            ctrl.pointsMeta.set(point.pointRid, point);
            ctrl.ridToPathKey.set(point.pointRid, point.pathKey);
          }
        });
      });

      ctrl.datasets(datasets);
      ctrl.loadConfiguration();
    };

    ctrl.initializePointBrowse = function () {
      var point = ctrl.pointRecord || {};
      var column = ctrl.pointColumn || {};
      var pointRid = ctrl.normalizeRid(point['@rid']);
      if (!pointRid) {
        ctrl.datasets([]);
        ctrl.visiblePoints(new Set());
        ctrl.error('Unable to determine which point to chart.');
        return false;
      }

      var path = Array.isArray(column.path) ? column.path : [];
      var datasetPathRecord = null;
      var equipmentPathRecord = null;
      var datasetPathIndex = -1;
      for (var pathIdx = path.length - 1; pathIdx >= 0; pathIdx--) {
        var pathRecord = path[pathIdx];
        if (!pathRecord) { continue; }
        if (pathRecord['@class'] === 'Dataset') {
          datasetPathRecord = pathRecord;
          datasetPathIndex = pathIdx;
          break;
        }
      }
      var equipmentPathEnd = datasetPathIndex >= 0 ? datasetPathIndex - 1 : path.length - 1;
      for (var equipmentPathIdx = equipmentPathEnd; equipmentPathIdx >= 0; equipmentPathIdx--) {
        var equipmentCandidate = path[equipmentPathIdx];
        var candidateClass = equipmentCandidate && equipmentCandidate['@class'];
        if (!equipmentCandidate || candidateClass === 'Location' || candidateClass === 'Dashboard' || candidateClass === 'Dataset' || candidateClass === 'Column' || candidateClass === 'Point') {
          continue;
        }
        equipmentPathRecord = equipmentCandidate;
        break;
      }

      var pointLabel = column.name || point.name || 'Point';
      var unitLabel = Point.formatUnit(point);
      var datasetName = column.datasetName || (datasetPathRecord && datasetPathRecord.name) || 'Default';
      var equipmentLabel = column.equipmentName || (equipmentPathRecord && equipmentPathRecord.name) || '';
      var datasetKey = (datasetPathRecord && datasetPathRecord['@rid']) || 'point-browse-dataset';
      var pathKey = datasetKey + '::' + pointLabel;
      var record = {
        key: column['@rid'] || (datasetKey + '::' + pointRid),
        name: pointLabel,
        pointRid: pointRid,
        unitLabel: unitLabel,
        datasetName: datasetName,
        chartType: column.chartType || (point.unit === 'bool' ? 'area-step' : 'line'),
        point: point,
        seriesLabel: pointLabel + (unitLabel ? ' (' + unitLabel + ')' : ''),
        equipmentLabel: equipmentLabel,
        equipmentRid: equipmentPathRecord && equipmentPathRecord['@rid'],
        equipmentClass: equipmentPathRecord && equipmentPathRecord['@class'],
        groupKey: datasetKey,
        pathKey: pathKey
      };

      ctrl.pointsMeta.clear();
      ctrl.pathKeyToCanonicalRid.clear();
      ctrl.ridToPathKey.clear();
      ctrl.pointsMeta.set(pointRid, record);
      ctrl.ridToPathKey.set(pointRid, pathKey);
      ctrl.datasets([{
        key: datasetKey,
        name: datasetName,
        displayName: datasetName,
        equipmentLabel: equipmentLabel,
        equipmentRid: record.equipmentRid,
        equipmentClass: record.equipmentClass,
        groupKey: datasetKey,
        points: [record]
      }]);
      ctrl.visiblePoints(new Set([pointRid]));
      return true;
    };

    ctrl.getComponentDepthLimit = function () {
      var el = ctrl.element();
      var componentDepthLimit = Number(el && el.componentDepthLimit != null ? el.componentDepthLimit : 1);
      if (!Number.isFinite(componentDepthLimit)) {
        componentDepthLimit = 1;
      }
      componentDepthLimit = Math.floor(componentDepthLimit);
      return componentDepthLimit < 0 ? 0 : componentDepthLimit;
    };

    ctrl.init = async function () {
      ctrl.loading(true);
      ctrl.error(null);
      try {
        var el = ctrl.element();
        ctrl.applyDefaultFormValues();
        if (ctrl.isPointBrowseVariant()) {
          if (!ctrl.initializePointBrowse()) {
            return;
          }
          if (edit.vm.editing()) {
            ctrl.pendingSeries = [];
            ctrl.pendingSeriesClear = true;
            ctrl.applyPendingSeries();
          } else {
            await ctrl.refreshChartData();
          }
          return;
        }
        var equipmentClasses = Array.isArray(el.equipmentClasses) ? el.equipmentClasses.filter(Boolean) : [];
        var params = {};
        if (equipmentClasses.length) {
          params.equipmentClasses = equipmentClasses.join(',');
        }
        var equipmentRid = (el.customEquipment != null ? String(el.customEquipment) : '').trim();
        if (!equipmentClasses.length && equipmentRid) {
          params.customEquipment = equipmentRid;
        }

        if (!Object.keys(params).length) {
          ctrl.datasets([]);
          ctrl.visiblePoints(new Set());
          ctrl.loading(false);
          return;
        }

        var equipmentLocationRid = getEquipmentLocationRid(el);
        if (!equipmentLocationRid) {
          throw new Error('Unable to determine location context for this Smart Chart.');
        }
        var equipmentLocationFragment = equipmentLocationRid.charAt(0) === '#' ? equipmentLocationRid.slice(1) : equipmentLocationRid;
        var componentDepthLimit = ctrl.getComponentDepthLimit();

        var fieldDiscovery = await loaders.requestWithLoader({
          loader: 'main',
          url: '/api/v1/entities/field-discovery',
          method: 'GET',
          params: Object.assign({}, params, {
            locationRid: equipmentLocationFragment,
            componentDepthLimit: componentDepthLimit,
            summaryOnly: 0
          })
        });

        var discoveredDatasets = fieldDiscovery && Array.isArray(fieldDiscovery.datasets)
          ? fieldDiscovery.datasets
          : [];
        if (!discoveredDatasets.length) {
          ctrl.error(equipmentClasses.length ?
            'No equipment found for the selected equipment classes.' :
            'Unable to locate equipment for Chart.'
          );
          ctrl.datasets([]);
          ctrl.visiblePoints(new Set());
          ctrl.loading(false);
          return;
        }

        ctrl.normalizeFieldDiscovery(fieldDiscovery);
        if (edit.vm.editing()) {
          ctrl.pendingSeries = [];
          ctrl.pendingSeriesClear = true;
          ctrl.applyPendingSeries();
        } else {
          await ctrl.refreshChartData();
        }
      } catch (err) {
        ctrl.error(err && err.message ? err.message : 'Failed to load Chart data.');
      } finally {
        ctrl.loading(false);
        m.redraw();
      }
    };

    ctrl.scheduleChartRefresh = function () {
      if (!ctrl.chart) {
        return;
      }
      setTimeout(function () {
        if (ctrl.chart && typeof ctrl.chart.flush === 'function') {
          ctrl.chart.flush();
        }
        if (ctrl.chart && typeof ctrl.chart.resize === 'function') {
          ctrl.chart.resize();
        }
      }, 0);
    };

    ctrl.toggleExpanded = function (event) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
        event.stopPropagation();
      }
      if (edit.vm.editing()) {
        return;
      }
      var next = !ctrl.isExpanded();
      ctrl.isExpanded(next);
      ctrl.controlsOpen(false);
      ctrl.closeYBoundsPopover();
      if (next && !ctrl.hasInitialized) {
        ctrl.hasInitialized = true;
        ctrl.init();
      }
      if (next) {
        ctrl.scheduleChartRefresh();
      }
      m.redraw();
    };

    ctrl.collectGroupPointRids = function (rid) {
      var normalizedRid = ctrl.normalizeRid(rid);
      if (!normalizedRid) {
        return [];
      }
      var meta = ctrl.pointsMeta.get(normalizedRid);
      if (!meta || !meta.groupKey) {
        var directPathKey = meta && meta.pathKey ? meta.pathKey : null;
        if (directPathKey) {
          ctrl.ridToPathKey.set(normalizedRid, directPathKey);
          if (!ctrl.pathKeyToCanonicalRid.has(directPathKey)) {
            ctrl.pathKeyToCanonicalRid.set(directPathKey, normalizedRid);
          }
        }
        return [normalizedRid];
      }
      var targetName = meta.name;
      var groupKey = meta.groupKey;
      if (!targetName) {
        var metaPathKey = meta.pathKey;
        if (metaPathKey) {
          ctrl.ridToPathKey.set(normalizedRid, metaPathKey);
          if (!ctrl.pathKeyToCanonicalRid.has(metaPathKey)) {
            ctrl.pathKeyToCanonicalRid.set(metaPathKey, normalizedRid);
          }
        }
        return [normalizedRid];
      }
      var collected = new Set();
      ctrl.datasets().forEach(function (dataset) {
        if (!dataset || dataset.groupKey !== groupKey) {
          return;
        }
        (dataset.points || []).forEach(function (point) {
          if (!point || point.name !== targetName || !point.pointRid) {
            return;
          }
          var pointRid = ctrl.normalizeRid(point.pointRid);
          if (pointRid) {
            collected.add(pointRid);
            var pathKey = meta && meta.pathKey ? meta.pathKey : null;
            if (!pathKey) {
              pathKey = ctrl.ridToPathKey.get(normalizedRid);
            }
            if (!pathKey) {
              pathKey = (dataset.groupKey || dataset.name || 'dataset') + '::' + targetName;
            }
            if (pathKey) {
              ctrl.ridToPathKey.set(pointRid, pathKey);
              if (!ctrl.pathKeyToCanonicalRid.has(pathKey)) {
                ctrl.pathKeyToCanonicalRid.set(pathKey, normalizedRid);
              }
            }
          }
        });
      });
      if (!collected.size) {
        collected.add(normalizedRid);
      }
      return Array.from(collected);
    };

    ctrl.getCanonicalRid = function (rid) {
      var normalized = ctrl.normalizeRid(rid);
      if (!normalized) {
        return null;
      }
      var pathKey = ctrl.ridToPathKey.get(normalized);
      if (!pathKey) {
        var meta = ctrl.pointsMeta.get(normalized);
        if (meta && meta.pathKey) {
          pathKey = meta.pathKey;
          ctrl.ridToPathKey.set(normalized, pathKey);
        }
      }
      if (!pathKey) {
        return normalized;
      }
      var canonical = ctrl.pathKeyToCanonicalRid.get(pathKey);
      if (!canonical) {
        canonical = normalized;
        ctrl.pathKeyToCanonicalRid.set(pathKey, canonical);
      }
      return canonical;
    };

    ctrl.getPointChoiceOptions = function () {
      var datasets = ctrl.datasets();
      if (!Array.isArray(datasets) || !datasets.length) {
        return [];
      }
      var selectedClassSet = null;
      if (ctrl.isBuilderVariant()) {
        var selectedClasses = ctrl.selectedClasses();
        if (Array.isArray(selectedClasses) && selectedClasses.length) {
          selectedClassSet = new Set(selectedClasses);
        }
      }
      ctrl.pathKeyToCanonicalRid.clear();
      ctrl.ridToPathKey.clear();
      var seenPaths = new Set();
      var options = [];
      datasets.forEach(function (dataset) {
        if (!dataset || !Array.isArray(dataset.points)) {
          return;
        }
        if (selectedClassSet && dataset.equipmentClass && !selectedClassSet.has(dataset.equipmentClass)) {
          return;
        }
        var datasetLabel = dataset.displayName || dataset.name || 'Dataset';
        dataset.points.forEach(function (point) {
          if (!point || !point.pointRid) {
            return;
          }
          var rid = ctrl.normalizeRid(point.pointRid);
          if (!rid) {
            return;
          }
          var meta = ctrl.pointsMeta.get(rid);
          if (selectedClassSet) {
            var pointClass = (meta && meta.equipmentClass) || dataset.equipmentClass || (point && point.equipmentClass);
            if (!pointClass || !selectedClassSet.has(pointClass)) {
              return;
            }
          }
          var pathKey = meta && meta.pathKey ? meta.pathKey : null;
          if (!pathKey) {
            var fallbackDatasetKey = dataset && dataset.groupKey ? dataset.groupKey : (dataset && dataset.name ? dataset.name : 'dataset');
            var pointName = point && point.name ? point.name : (meta && meta.name ? meta.name : 'point');
            pathKey = fallbackDatasetKey + '::' + pointName;
            if (meta) {
              meta.pathKey = pathKey;
              ctrl.pointsMeta.set(rid, meta);
            }
          }
          ctrl.ridToPathKey.set(rid, pathKey);
          if (pathKey && seenPaths.has(pathKey)) {
            return;
          }
          if (pathKey) {
            seenPaths.add(pathKey);
            ctrl.pathKeyToCanonicalRid.set(pathKey, rid);
          }
          var pointLabel = point.name || 'Point';
          var optionLabel = datasetLabel ? (datasetLabel + ' - ' + pointLabel) : pointLabel;
          options.push({
            value: rid,
            key: optionLabel
          });
        });
      });
      options.sort(function (a, b) {
        var aKey = a.key || '';
        var bKey = b.key || '';
        if (aKey < bKey) { return -1; }
        if (aKey > bKey) { return 1; }
        return 0;
      });
      return options;
    };

    ctrl.pruneVisiblePointsByClass = function () {
      if (!ctrl.isBuilderVariant()) {
        return;
      }
      var selected = ctrl.selectedClasses();
      if (!Array.isArray(selected) || !selected.length) {
        return;
      }
      var allowed = new Set(selected);
      var canonical = [];
      ctrl.visiblePoints().forEach(function (rid) {
        var meta = ctrl.pointsMeta.get(rid);
        var className = meta && meta.equipmentClass;
        if (className && allowed.has(className)) {
          var canonicalRid = ctrl.getCanonicalRid(rid);
          if (canonicalRid) {
            canonical.push(canonicalRid);
          }
        }
      });
      ctrl.visiblePointChoices(canonical);
    };

    ctrl.selectedClassChoices = function (values) {
      if (arguments.length === 0) {
        var current = ctrl.selectedClasses();
        return Array.isArray(current) ? current.slice() : [];
      }
      var incoming = Array.isArray(values) ? values.slice() : (values != null ? [values] : []);
      var normalized = [];
      incoming.forEach(function (value) {
        if (value != null && value !== '') {
          normalized.push(String(value));
        }
      });
      normalized = Array.from(new Set(normalized));
      var previous = ctrl.selectedClasses();
      var previousSignature = Array.isArray(previous) ? previous.slice().sort().join('|') : '';
      var sortedSignature = normalized.slice().sort().join('|');
      if (sortedSignature === previousSignature) {
        return normalized;
      }
      ctrl.selectedClasses(normalized);
      if (ctrl.isBuilderVariant()) {
        var elementRecord = ctrl.getElementRecord();
        if (elementRecord) {
          elementRecord.equipmentClasses = normalized.slice();
          var parentRid = elementRecord.parentRid || '';
          ctrl.builderLastClassSignature = parentRid + '::' + sortedSignature;
        }
        ctrl.visiblePoints(new Set());
        ctrl.datasets([]);
        ctrl.pointsMeta.clear();
        ctrl.pendingSeries = [];
        ctrl.pendingSeriesClear = true;
        ctrl.seriesCache.clear();
        ctrl.applyPendingSeries();
        if (normalized.length) {
          ctrl.hasInitialized = true;
          ctrl.init();
        } else {
          ctrl.hasInitialized = false;
          ctrl.loading(false);
          ctrl.error(null);
          if (ctrl.chartRefreshing && typeof ctrl.chartRefreshing === 'function') {
            ctrl.chartRefreshing(false);
          }
        }
      } else {
        ctrl.pruneVisiblePointsByClass();
      }
      return normalized;
    };

    ctrl.visiblePointChoices = function (values) {
      if (arguments.length === 0) {
        var currentSet = ctrl.visiblePoints();
        var canonicalSelections = new Set();
        if (currentSet && typeof currentSet.forEach === 'function') {
          currentSet.forEach(function (rid) {
            var canonical = ctrl.getCanonicalRid(rid);
            if (canonical && ctrl.pointsMeta.has(ctrl.normalizeRid(canonical))) {
              canonicalSelections.add(canonical);
            }
          });
        }
        return Array.from(canonicalSelections).sort();
      }

      var incoming = Array.isArray(values) ? values.slice() : (values != null ? [values] : []);
      var incomingCanonical = new Set();
      incoming.forEach(function (rid) {
        var canonical = ctrl.getCanonicalRid(rid);
        if (canonical && ctrl.pointsMeta.has(ctrl.normalizeRid(canonical))) {
          incomingCanonical.add(canonical);
        }
      });

      var existing = ctrl.visiblePoints();
      var previousActual = new Set();
      var previousCanonical = new Set();
      if (existing && typeof existing.forEach === 'function') {
        existing.forEach(function (rid) {
          var normalized = ctrl.normalizeRid(rid);
          if (normalized && ctrl.pointsMeta.has(normalized)) {
            previousActual.add(normalized);
            var canonical = ctrl.getCanonicalRid(normalized);
            if (canonical && ctrl.pointsMeta.has(ctrl.normalizeRid(canonical))) {
              previousCanonical.add(canonical);
            }
          }
        });
      }

      var nextSet = new Set(previousActual);
      var addedCanonical = [];
      incomingCanonical.forEach(function (canonical) {
        if (!previousCanonical.has(canonical)) {
          addedCanonical.push(canonical);
        }
      });
      var removedCanonical = [];
      previousCanonical.forEach(function (canonical) {
        if (!incomingCanonical.has(canonical)) {
          removedCanonical.push(canonical);
        }
      });

      addedCanonical.forEach(function (canonicalRid) {
        ctrl.collectGroupPointRids(canonicalRid).forEach(function (groupRid) {
          nextSet.add(groupRid);
        });
      });
      removedCanonical.forEach(function (canonicalRid) {
        ctrl.collectGroupPointRids(canonicalRid).forEach(function (groupRid) {
          nextSet.delete(groupRid);
        });
      });

      var validSet = new Set();
      nextSet.forEach(function (rid) {
        if (ctrl.pointsMeta.has(rid)) {
          validSet.add(rid);
        }
      });
      ctrl.visiblePoints(validSet);
      ctrl.seriesCache.clear();

      var persistPromise = ctrl.saveVisiblePoints(true);
      if (edit.vm.editing()) {
        ctrl.pendingSeries = [];
        ctrl.pendingSeriesClear = true;
        ctrl.applyPendingSeries();
        if (persistPromise && typeof persistPromise.catch === 'function') {
          persistPromise.catch(function () {});
        }
        m.redraw();
      } else {
        var refresh = function () { return ctrl.refreshChartData(); };
        if (persistPromise && typeof persistPromise.then === 'function') {
          persistPromise.then(refresh).catch(function () {});
        } else {
          try {
            refresh();
          } catch (err) {
            // ignore errors triggered by programmatic refresh
          }
        }
      }

      var canonicalResult = new Set();
      validSet.forEach(function (rid) {
        var canonical = ctrl.getCanonicalRid(rid);
        if (canonical) {
          canonicalResult.add(canonical);
        }
      });
      return Array.from(canonicalResult).sort();
    };

    ctrl.renderPointSelector = function (opts) {
      opts = opts || {};
      var options = ctrl.getPointChoiceOptions();
      if (!options.length) {
        var emptyMessage = opts.emptyMessage || 'No points available for the selected equipment.';
        var emptyKey = (opts.keyPrefix || 'smartchart-point-selector') + '-empty';
        return m('div.f4.mv2', { key: emptyKey }, emptyMessage);
      }
      var optionSignature = options.map(function (option) { return option.value + ':' + option.key; }).join('|');
      var selectionSignatureArray = ctrl.visiblePointChoices();
      var selectionSignature = Array.isArray(selectionSignatureArray) ? selectionSignatureArray.join('|') : '';
      var keyPrefix = opts.keyPrefix || 'smartchart-point-selector';
      var containerStyle = Object.assign({
        '--smartchart-choice-rows': ctrl.maxVisibleChoices
      }, opts.style || {});
      var containerClass = 'smartchart-point-selector' + (opts.className ? ' ' + opts.className : '');
      var labelText = opts.label || 'Selected Points:';
      var labelClass = opts.labelClass || 'db mb1';
      return m('div.w-100', {
        'class': containerClass,
        key: keyPrefix + '-' + optionSignature + '::' + selectionSignature,
        style: containerStyle
      }, [
        m('label', { 'class': labelClass }, labelText),
        m(choices, {
          data: options,
          value: ctrl.visiblePointChoices,
          placeholderValue: opts.placeholderValue || 'Click to add point'
        })
      ]);
    };

    ctrl.renderClassSelector = function () {
      if (!ctrl.isBuilderVariant()) {
        return null;
      }
      var baseKey = 'smartchart-class-selector';
      if (!ctrl.builderClassesLoaded()) {
        return m('div.mv2', {
          key: baseKey + '-loading'
        }, [
          m('span.i', 'Loading classes…')
        ]);
      }
      if (ctrl.builderClassesError()) {
        return m('div.mv2.red', {
          key: baseKey + '-error'
        }, ctrl.builderClassesError());
      }
      var options = ctrl.builderClassOptions();
      if (!Array.isArray(options) || !options.length) {
        return m('div.mv2.i', {
          key: baseKey + '-empty'
        }, 'No equipment classes available.');
      }
      var optionSignature = options.map(function (option) { return option.value + ':' + option.key; }).join('|');
      var valueSignature = (ctrl.selectedClasses() || []).join('|');
      var children = [
        m('label', { 'class': 'db mb1' }, 'Classes'),
        m(choices, {
          data: options,
          value: ctrl.selectedClassChoices,
          placeholderValue: 'Select classes'
        })
      ];
      if (ctrl.error()) {
        children.push(m('div.mt2.red', ctrl.error()))
      }
      return m('div', {
        key: baseKey + '-options::' + optionSignature + '::' + valueSignature
      }, children);
    };

    ctrl.renderDatasets = function () {
      var datasets = ctrl.datasets();
      if (!datasets.length) {
        return m('div.mv2.i', 'No datasets found for the selected equipment.');
      }
      var datasetsSignature = datasets.map(function (dataset) { return dataset.key; }).join('|');
      return m('div', {
        key: 'smartchart-datasets-' + datasetsSignature
      }, [
        ctrl.renderPointSelector()
      ]);
    };

    ctrl.getControlsState = function () {
      var spanValue = ctrl.form.span ? ctrl.form.span() : '';
      var samplingValue = ctrl.form.resampling ? ctrl.form.resampling() : '';
      var exportDisabled = !ctrl.latestSeriesData || ctrl.latestSeriesData.size === 0;
      var endMoment = ctrl.form.start && ctrl.form.start() ? moment(ctrl.form.start()) : null;
      var endingLabel = endMoment && endMoment.isValid() ? endMoment.format('MM/DD/YYYY h:mm A') : 'Now';
      var samplingLabel = samplingValue ? samplingValue.charAt(0).toUpperCase() + samplingValue.slice(1) : '';
      var summaryParts = [];
      if (spanValue) {
        summaryParts.push(spanValue);
      }
      if (samplingLabel) {
        summaryParts.push(samplingLabel);
      }
      summaryParts.push('Ending ' + endingLabel);
      var summary = summaryParts.join(' ');
      return {
        spanValue: spanValue,
        samplingValue: samplingValue,
        exportDisabled: exportDisabled,
        endingLabel: endingLabel,
        summary: summary
      };
    };

    ctrl.renderControlsSummary = function () {
      return ctrl.getControlsState().summary;
    };

    ctrl.resolveSpanUnit = function (resampleValue) {
      var unitMap = {
        milliseconds: 'milliseconds',
        seconds: 'seconds',
        minutes: 'minutes',
        hour: 'hours',
        hours: 'hours',
        days: 'days'
      };
      return unitMap[resampleValue] || 'hours';
    };

    ctrl.formatSpanValue = function (value) {
      if (!Number.isFinite(value)) {
        return '';
      }
      var rounded = Math.ceil(value);
      if (rounded < 1) {
        rounded = 1;
      }
      return String(rounded);
    };

    ctrl.formatUnitLabel = function (value, unit) {
      var unitsMap = {
        milliseconds: ['Millisecond', 'Milliseconds'],
        seconds: ['Second', 'Seconds'],
        minutes: ['Minute', 'Minutes'],
        hours: ['Hour', 'Hours'],
        days: ['Day', 'Days']
      };
      var labels = unitsMap[unit] || [unit.charAt(0).toUpperCase() + unit.slice(1), unit.charAt(0).toUpperCase() + unit.slice(1)];
      var isSingular = Math.abs(value) === 1;
      return isSingular ? labels[0] : labels[1];
    };

    ctrl.getSpanAdjustment = function (fraction) {
      var fractionValue = Number(fraction);
      if (!Number.isFinite(fractionValue) || fractionValue <= 0) {
        fractionValue = 0.5;
      }
      fractionValue = Math.min(1, Math.max(0.01, Math.abs(fractionValue)));
      var el = typeof ctrl.element === 'function' ? ctrl.element() : ctrl.element;
      var rawSpan = ctrl.form.span ? ctrl.form.span() : null;
      var spanValue = parseFloat(rawSpan);
      if (!Number.isFinite(spanValue) || spanValue <= 0) {
        var fallbackSpan = el && el.chartSpan != null ? parseFloat(el.chartSpan) : NaN;
        spanValue = fallbackSpan;
      }
      if (!Number.isFinite(spanValue) || spanValue <= 0) {
        spanValue = 8;
      }
      var resample = (ctrl.form.resampling && ctrl.form.resampling()) || (el && el.chartResample) || 'hours';
      var unit = ctrl.resolveSpanUnit(resample);
      var adjustment = Math.round(spanValue * fractionValue);
      if (!Number.isFinite(adjustment) || adjustment <= 0) {
        adjustment = 1;
      }
      if (adjustment < 1) {
        adjustment = 1;
      }
      return {
        adjustment: adjustment,
        unit: unit
      };
    };

    ctrl.getSpanShiftDescription = function (fraction, direction) {
      var details = ctrl.getSpanAdjustment(fraction);
      if (!details) {
        return direction === 'forward' ? 'Increase range' : 'Decrease range';
      }
      var verb = direction === 'forward' ? 'Increase' : 'Decrease';
      var valueLabel = ctrl.formatSpanValue(details.adjustment);
      var unitLabel = ctrl.formatUnitLabel(details.adjustment, details.unit);
      return verb + ' ending time by ' + valueLabel + ' ' + unitLabel;
    };

    ctrl.adjustEndDateByFraction = async function (fraction, direction) {
      if (edit.vm.editing()) {
        return;
      }
      var details = ctrl.getSpanAdjustment(fraction);
      if (!details) {
        return;
      }
      var startValue = ctrl.form.start && ctrl.form.start();
      var startMoment = startValue && typeof startValue.clone === 'function' ? startValue.clone() : moment(startValue);
      if (!startMoment || !startMoment.isValid()) {
        startMoment = moment();
      }
      var directionFactor = direction === 'forward' ? 1 : -1;
      startMoment.add(directionFactor * details.adjustment, details.unit);
      ctrl.form.start(startMoment);
      return ctrl.debouncedShift({
        direction: direction,
        fraction: fraction
      });
    };

    ctrl.renderShiftControl = function (options) {
      options = options || {};
      var fraction = options.fraction != null ? options.fraction : 0.5;
      var direction = options.direction === 'backward' ? 'backward' : 'forward';
      var iconCount = Number.isInteger(options.iconCount) && options.iconCount > 0 ? options.iconCount : 1;
      var description = ctrl.getSpanShiftDescription(fraction, direction);
      var baseClass = options.baseClass || 'ba br3 ph2 pv1 dib pointer flex items-center justify-center f5';
      var className = baseClass + (options.className ? ' ' + options.className : '');
      var style = Object.assign({ backgroundColor: '#212121' }, options.style || {});
      var iconName = direction === 'forward' ? 'ion-chevron-right' : 'ion-chevron-left';
      var icons = [];
      for (var i = 0; i < iconCount; i++) {
        icons.push(m('i', {
          class: iconName + ' blue' + (i > 0 ? ' ml1' : '')
        }));
      }
      return m('div', {
        class: className,
        style: style,
        role: 'button',
        tabindex: 0,
        title: description,
        'aria-label': description,
        onclick: function (event) {
          event.stopPropagation();
          ctrl.adjustEndDateByFraction(fraction, direction);
        },
        onkeydown: function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar' || event.key === 'Space') {
            event.preventDefault();
            ctrl.adjustEndDateByFraction(fraction, direction);
          }
        }
      }, icons);
    };

    ctrl.renderYBoundsPopover = function () {
      if (!ctrl.yBoundsOpen()) {
        return null;
      }
      var el = ctrl.getElementRecord();
      var ridFragment = el && el['@rid'] ? el['@rid'].toString().replace(/[#:]/g, '-') : 'smartchart';
      return m('div.smart-chart-y-bounds-popover.absolute.mt2.z-999.ba.b--light-gray.br2.shadow-4.pa3', {
        style: { right: 0, minWidth: '16rem', backgroundColor: '#212121' },
        onclick: function (event) {
          event.stopPropagation();
        }
      }, [
        m('div.flex.justify-between.items-center.mb2', [
          m('span.f5', 'Y Axis Bounds'),
          m('i.ion-close.blue.pointer', {
            onclick: function (event) {
              event.stopPropagation();
              ctrl.closeYBoundsPopover();
            }
          })
        ]),
        ctrl.yBoundsError() ? m('div.red.mb2', ctrl.yBoundsError()) : null,
        m('div.mb2', [
          m('label.db.mb1', { for: ridFragment + '-axis-min' }, 'Minimum'),
          m('input.input-reset.w-100.pa2.ba.b--light-gray.bg-transparent.white', {
            id: ridFragment + '-axis-min',
            type: 'number',
            value: ctrl.tempYMin(),
            oninput: function (event) {
              ctrl.tempYMin(event.target.value);
              ctrl.yBoundsError(null);
            }
          })
        ]),
        m('div.mb3', [
          m('label.db.mb1', { for: ridFragment + '-axis-max' }, 'Maximum'),
          m('input.input-reset.w-100.pa2.ba.b--light-gray.bg-transparent.white', {
            id: ridFragment + '-axis-max',
            type: 'number',
            value: ctrl.tempYMax(),
            oninput: function (event) {
              ctrl.tempYMax(event.target.value);
              ctrl.yBoundsError(null);
            }
          })
        ]),
        m('div.flex.justify-end', [
          m(button, {
            class: 'mr2',
            label: 'Clear',
            func: ctrl.clearYBounds
          }),
          m(button, {
            class: 'blue',
            label: 'Apply',
            func: ctrl.applyYBounds
          })
        ])
      ]);
    };

    ctrl.renderYBoundsControl = function () {
      if (edit.vm.editing()) {
        return null;
      }
      var el = ctrl.getElementRecord();
      var currentMax = el && el.yMax != null ? el.yMax : null;
      var currentMin = el && el.yMin != null ? el.yMin : null;
      var summary;
      if (currentMax == null && currentMin == null) {
        summary = 'Y Axis: Auto';
      } else {
        var minLabel = currentMin == null ? 'Auto' : String(currentMin);
        var maxLabel = currentMax == null ? 'Auto' : String(currentMax);5
        summary = 'Y Axis: ' + minLabel + ' to ' + maxLabel;
      }
      return m('div.relative.ml2', [
        m('div.ba.br3.ph2.pv1.dib.pointer.flex.items-center.f5', {
          style: { backgroundColor: '#212121' },
          role: 'button',
          tabindex: 0,
          onclick: ctrl.toggleYBoundsPopover,
          onkeydown: function (event) {
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar' || event.key === 'Space') {
              event.preventDefault();
              ctrl.toggleYBoundsPopover(event);
            }
          }
        }, [
          m('span.mr2', summary),
          m('i.ion-chevron-down.blue')
        ]),
        ctrl.renderYBoundsPopover()
      ]);
    };

    ctrl.renderValueFieldSelector = function (options) {
      options = options || {};
      var selectId = options.id || undefined;
      var containerClass = 'ba br3 ph2 pv1 dib flex items-center justify-center f5' + (options.className ? ' ' + options.className : '');
      var containerStyle = Object.assign({ backgroundColor: '#212121' }, options.style || {});
      var selectClass = options.selectClass || 'blue bn pointer';
      var selectStyle = Object.assign({}, options.selectStyle || {});
      var optionStyle = options.optionStyle || { color: '#DDD'};
      var optionElements = [
        m('option', { value: 'mean', style: optionStyle }, 'Mean'),
        m('option', { value: 'min', style: optionStyle }, 'Min'),
        m('option', { value: 'max', style: optionStyle }, 'Max')
      ];
      var valueLabelMap = { mean: 'Mean', min: 'Min', max: 'Max' };
      var currentValue = ctrl.form.valueField ? ctrl.form.valueField() : 'mean';
      var currentLabel = valueLabelMap[currentValue] || valueLabelMap.mean;
      containerStyle = Object.assign({ position: 'relative' }, containerStyle);
      return m('div', {
        class: containerClass,
        style: containerStyle
      }, [
        m('i.ion-android-stats-bars.blue.mr2'),
        m('span.mr2', 'Select: ' + currentLabel),
        m('i.ion-chevron-down.blue'),
        m('select', {
          id: selectId,
          class: selectClass,
          style: Object.assign({ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }, selectStyle),
          value: currentValue,
          onchange: function (event) {
            event.stopPropagation();
            var nextValue = ctrl.normalizeValueField(event.target.value);
            if (ctrl.form.valueField && ctrl.form.valueField() === nextValue) {
              return;
            }
            if (ctrl.form.valueField) {
              ctrl.form.valueField(nextValue);
            }
            var elementRecord = typeof ctrl.element === 'function' ? ctrl.element() : ctrl.element;
            if (elementRecord) {
              elementRecord.smartChartValueField = nextValue;
            }
            ctrl.refreshChartData();
          },
          onclick: function (event) {
            event.stopPropagation();
          },
          onkeydown: function (event) {
            event.stopPropagation();
          }
        }, optionElements)
      ]);
    };

    ctrl.renderControlsPopover = function () {
      if (!ctrl.controlsOpen()) {
        return null;
      }

      var elementRecord = typeof ctrl.element === 'function' ? ctrl.element() : null;
      var ridFragment = elementRecord && elementRecord['@rid'] ? elementRecord['@rid'].replace(/[#:]/g, '-') : 'smartchart';
      var spanId = ridFragment + '-span-input';
      var samplingId = ridFragment + '-sampling-input';
      var endDateId = ridFragment + '-end-date';
      var state = ctrl.getControlsState();

      return m('div.smart-chart-controls-popover.absolute.mt2.z-999.ba.b--light-gray.br2.shadow-4.pa3', {
        style: { left: '50%', transform: 'translateX(-50%)', minWidth: '22rem', backgroundColor: '#212121' },
        onclick: function (event) {
          event.stopPropagation();
        }
      }, [
        m('div.dn.db-m.db-l', [
          m('div.flex.justify-between.flex-wrap.items-end', [
            m('div.f5', [
              m('form.flex.justify-center', { role: 'form' }, [
                m('div.mr2', [
                  m('label', { for: spanId }, 'Span'),
                  m('input.mb0.w4', {
                    id: spanId,
                    style: { width: '5em' },
                    type: 'number',
                    autocomplete: 'off',
                    value: state.spanValue,
                    oninput: function (ev) { ctrl.form.span(ev.target.value); }
                  })
                ]),
                m('div.mr2', [
                  m('label', { for: samplingId }, 'Sampling'),
                  m('select.input-reset.mb0.w4', {
                    id: samplingId,
                    autocomplete: 'off',
                    value: state.samplingValue,
                    onchange: function (ev) { ctrl.form.resampling(ev.target.value); }
                  }, [
                    m('option', { value: 'hours' }, 'Hours (15m)'),
                    m('option', { value: 'hour' }, 'Hours'),
                    m('option', { value: 'days' }, 'Days'),
                    m('option', { value: 'minutes' }, 'Minutes'),
                    m('option', { value: 'seconds' }, 'Seconds'),
                    m('option', { value: 'milliseconds' }, 'Milliseconds')
                  ])
                ]),
                m('div', { style: { width: '11.5em' } }, [
                  m('label', { for: endDateId }, 'Ending'),
                  m(pikaday, { id: endDateId, value: ctrl.form.start, dateFormat: 'm/d/Y h:i K' })
                ])
              ])
            ]),
            m('div.mt3.flex.justify-center.items-center', [
              ctrl.renderShiftControl({
                fraction: 0.75,
                direction: 'backward',
                iconCount: 2,
                className: 'mr3'
              }),
              ctrl.renderShiftControl({
                fraction: 0.25,
                direction: 'backward',
                iconCount: 1,
                className: 'mr2'
              }),
              ctrl.renderShiftControl({
                fraction: 0.25,
                direction: 'forward',
                iconCount: 1,
                className: 'ml2'
              }),
              ctrl.renderShiftControl({
                fraction: 0.75,
                direction: 'forward',
                iconCount: 2,
                className: 'ml3'
              })
            ]),
            m('div.mt3.tc.flex.justify-end', [
              m(button, {
                func: state.exportDisabled ? null : function () { ctrl.exportVisibleData(); },
                label: m('span.green.f5', ['Export', m('i.ion-document.ml2')]),
                class: 'mr2 w4' + (state.exportDisabled ? ' o-50' : '')
              }),
              m(button, {
                func: function () { ctrl.refreshChartData(); },
                label: m('span.blue.f5', ['Chart', m('i.ion-arrow-graph-up-right.ml2')]),
                class: 'w4'
              })
            ])
          ])
        ]),
        m('div.dn-m.dn-l', [
          m('div.mb2', [
            m('label', { for: spanId + '-sm' }, 'Span'),
            m('input.mb0.w4', {
              id: spanId + '-sm',
              style: { width: '100%' },
              type: 'number',
              autocomplete: 'off',
              value: state.spanValue,
              oninput: function (ev) { ctrl.form.span(ev.target.value); }
            })
          ]),
          m('div.mb2', [
            m('label', { for: samplingId + '-sm' }, 'Sampling'),
            m('select.input-reset.mb0.w-100', {
              id: samplingId + '-sm',
              autocomplete: 'off',
              value: state.samplingValue,
              onchange: function (ev) { ctrl.form.resampling(ev.target.value); }
            }, [
              m('option', { value: 'hours' }, 'Fifteen Minutes'),
              m('option', { value: 'hour' }, 'Hours'),
              m('option', { value: 'days' }, 'Days'),
              m('option', { value: 'minutes' }, 'Minutes'),
              m('option', { value: 'seconds' }, 'Seconds'),
              m('option', { value: 'milliseconds' }, 'Milliseconds')
            ])
          ]),
          m('div.mb2', { style: { width: '100%' } }, [
            m('label', { for: endDateId + '-sm' }, 'Ending'),
            m(pikaday, { id: endDateId + '-sm', value: ctrl.form.start, dateFormat: 'm/d/Y h:i K' })
          ]),
          m('div.mt3.flex.justify-center.items-center', [
            ctrl.renderShiftControl({
              fraction: 0.9,
              direction: 'backward',
              iconCount: 2,
              className: 'mr3'
            }),
            ctrl.renderShiftControl({
              fraction: 0.1,
              direction: 'backward',
              iconCount: 1,
              className: 'mr2'
            }),
            ctrl.renderShiftControl({
              fraction: 0.1,
              direction: 'forward',
              iconCount: 1,
              className: 'ml2'
            }),
            ctrl.renderShiftControl({
              fraction: 0.9,
              direction: 'forward',
              iconCount: 2,
              className: 'ml3'
            })
          ]),
          m('div.mt3.tc.flex', [
            m(button, {
              func: state.exportDisabled ? null : function () { ctrl.exportVisibleData(); },
              label: m('span.green', ['Export', m('i.ion-document.ml1')]),
              class: 'w-50 mr1' + (state.exportDisabled ? ' o-50' : '')
            }),
            m(button, {
              func: function () { ctrl.refreshChartData(); },
              label: ['Chart', m('i.ion-arrow-graph-up-right')],
              class: 'w-50 ml1 blue'
            })
          ])
        ])
      ]);
    };

    // Render the C3 chart container and keep the chart reference in sync
    ctrl.renderChart = function () {
      var visibleCount = ctrl.visiblePoints().size;
      var isEditing = edit.vm.editing();
      var emptyMessage;
      if (isEditing) {
        emptyMessage = 'No points selected yet. Choose points above to preview the chart.';
      } else if (ctrl.isBuilderVariant()) {
        emptyMessage = 'Select points to chart using the controls above.';
      } else {
        emptyMessage = 'No points selected. Use edit mode to show points.';
      }
      var children = [
        visibleCount === 0 ?
          m('div.mv2.mid-gray', emptyMessage) :
          null,
        m(c3, {
          options: ctrl.chartOptions,
          oncreate: function (chartVnode) {
            ctrl.chart = chartVnode.state.chart;
            ctrl.applyPendingSeries();
            ctrl.scheduleChartRefresh();
            m.redraw();
          },
          onupdate: function (chartVnode) {
            ctrl.chart = chartVnode.state.chart;
            ctrl.applyPendingSeries();
            if (ctrl.isExpanded()) {
              ctrl.scheduleChartRefresh();
            }
          }
        })
      ];      
      if (ctrl.chartRefreshing && ctrl.chartRefreshing()) {
        children.push(
          m('div.absolute.top-0.left-0.w-100.h-100.flex.items-center.justify-center', {
            style: {
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
              pointerEvents: 'none'
            }
          }, [
            m('img', {
              src: '/images/loading-bars.svg',
              style: { width: '64px', height: '64px' },
              alt: 'Loading chart data'
            })
          ])
        );
      }
      return m('div.relative.smart-chart-viewport', {
        style: {
          overflow: 'hidden',
          backgroundColor: '#212121'
        },
        oncreate: function (vnode) {
          ctrl.chartStage = vnode.dom;
        },
        onupdate: function (vnode) {
          ctrl.chartStage = vnode.dom;
        }
      }, children);
    };

    if (ctrl.isBuilderVariant()) {
      if (typeof ctrl.legendCollapsed === 'function') {
        ctrl.legendCollapsed(false);
      }
      ctrl.loadBuilderClassOptions();
      var initialRecord = ctrl.getElementRecord();
      if (initialRecord) {
        var parentRid = initialRecord.parentRid || '';
        var initialSignature = Array.isArray(initialRecord.equipmentClasses)
          ? initialRecord.equipmentClasses.filter(Boolean).slice().sort().join('|')
          : '';
        ctrl.builderLastClassSignature = parentRid + '::' + initialSignature;
      }
    } else if (ctrl.isPointBrowseVariant()) {
      ctrl.legendCollapsed(false);
      ctrl.isExpanded(true);
      ctrl.hasInitialized = true;
      ctrl.init();
    } else if (edit.vm.editing()) {
      ctrl.hasInitialized = true;
      ctrl.init();
    }
  },

  onremove: function () {
    if (typeof this.detachModalDateControlsListener === 'function') {
      this.detachModalDateControlsListener();
    }
    if (this.debouncedShift && typeof this.debouncedShift.cancel === 'function') {
      this.debouncedShift.cancel();
    }
    if (typeof this.finishActiveChartSlide === 'function') {
      this.finishActiveChartSlide();
    }
    if (typeof this.cancelYAxisTransition === 'function') {
      this.cancelYAxisTransition();
    }
    this.chartStage = null;
  },

  // Compose the Chart panel with heading, legend, editor controls, and chart
  view: function () {
    var ctrl = this;
    var el = ctrl.element();
    var isEditing = edit.vm.editing();
    var ridFragment = el && el['@rid'] ? el['@rid'].toString().replace(/[#:]/g, '-') : 'smartchart';
    var inlineValueFieldId = ridFragment + '-value-field-inline';
    if (ctrl._legendPreviousEditing !== isEditing) {
      if (typeof ctrl.legendCollapsed === 'function') {
        ctrl.legendCollapsed(isEditing ? false : true);
      }
      ctrl._legendPreviousEditing = isEditing;
    }
    var isPointBrowse = ctrl.isPointBrowseVariant();
    var isExpanded = isPointBrowse || ctrl.isExpanded() || isEditing;
    var containerClass = isPointBrowse
      ? 'cf f3 point-trend-modal-chart'
      : 'cf bw1 b--grey f3 ' + (isExpanded ? 'pv3 bt bl' : 'pv3 ba');
    var containerStyle = !isPointBrowse && isExpanded ? { borderLeftStyle: 'dotted' } : undefined;
    if (!containerStyle) {
      containerStyle = {};
    }
    containerStyle.overflow = 'visible';

    var headerInner;
    if (isEditing) {
      var elementRecord = el || {};
      headerInner = m('div.f2.ml2.mb2.flex.justify-between.items-center.narrow.grid-item-drag-handle', {
        style: { cursor: 'grab' }
      }, [
        m('span.blue', {
          onclick: function () {
            if (!elementRecord) { return; }
            var canDelete = elementRecord.name !== 'Default';
            elementForm.editDialogue(elementRecord, {
              delete: canDelete,
              move: 'true',
              submitCallback: ctrl.parentReinitialize,
              dashboardCallback: ctrl.dashboardCallback
            });
          }
        }, elementRecord && elementRecord.name ? elementRecord.name : m('i.ion-edit.blue'))
      ]);
    } else if (!isExpanded) {
      var label = el.name || 'Chart';
      var summaryNode;
      if (ctrl.isBuilderVariant()) {
        summaryNode = m('i.ion-chevron-down.blue.ml3.mr3.f3');
      } else {
        var summaryText = ctrl.renderControlsSummary();
        summaryNode = m('div.ba.br3.ph2.pv1.dib.f5.flex.items-center.justify-end.pointer.ml3.mr2', {
          style: { backgroundColor: '#212121' }
        }, [
          m('span.white.mr2', summaryText),
          m('i.ion-chevron-down.blue')
        ]);
      }
      headerInner = m('div.flex.items-center.pointer.w-100', {
        onclick: ctrl.toggleExpanded
      }, [
        m('div.flex.items-center', [
          m('div', {
            class: 'f2 truncate ml2 pointer',
            onclick: ctrl.toggleExpanded
          }, label),
          el.helpText ?
            m('i.ion-ios-information-outline.white.f2.ml2.pointer', {
              onclick: function (event) {
                event.stopPropagation();
                helpModal.editDialogue(label, undefined, el.helpText);
              }
            })
          : null
        ]),
        m('div.flex.items-center.justify-end', {
          style: { marginLeft: 'auto', flexGrow: 1 }
        }, summaryNode ? [summaryNode] : [])
      ]);
    } else {
      var expandedLabel = el.name || 'Chart';
      var expandedSummary = ctrl.renderControlsSummary();
      headerInner = m('div.flex.flex-wrap.items-center.justify-between', [
        m('div.flex.items-center.w-100', [
          ctrl.hideTitle ? null : m('div.flex.items-center', { style: { minWidth: 0 } }, [
            m('div', {
              class: 'f2 truncate' + (ctrl.isPointBrowseVariant() ? '' : ' pointer'),
              onclick: ctrl.isPointBrowseVariant() ? undefined : ctrl.toggleExpanded
            }, expandedLabel),
            el.helpText ?
              m('i.ion-ios-information-outline.white.f2.ml2.pointer', {
                onclick: function (event) {
                  event.stopPropagation();
                  helpModal.editDialogue(expandedLabel, undefined, el.helpText);
                }
              })
            : null
          ]),
          m('div.flex.items-center.mv2', { style: { marginLeft: 'auto' } }, [
            ctrl.isBuilderVariant() ?
              m('div.flex.flex-column.items-end.mr3', [
                m('div.ba.br3.ph2.pv1.dib.pointer.flex.items-center.justify-center.f5' + (ctrl.builderSaving() ? ' o-50' : ''), {
                  style: { backgroundColor: '#212121' },
                  role: 'button',
                  tabindex: ctrl.builderSaving() ? -1 : 0,
                  title: 'Save Chart to this location',
                  'aria-disabled': ctrl.builderSaving() ? 'true' : 'false',
                  onclick: function (event) {
                    event.stopPropagation();
                    if (!ctrl.builderSaving()) {
                      ctrl.saveBuilderElement();
                    }
                  },
                  onkeydown: function (event) {
                    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar' || event.key === 'Space') {
                      event.preventDefault();
                      event.stopPropagation();
                      if (!ctrl.builderSaving()) {
                        ctrl.saveBuilderElement();
                      }
                    }
                  }
                }, [
                  m('i', {
                    class: (ctrl.builderSaving() ? 'ion-load-c ion-spin' : 'ion-archive') + ' blue'
                  }),
                  m('span.ml2', ctrl.builderSaving() ? 'Saving...' : 'Save')
                ]),
                ctrl.builderSaveStatus() ?
                  m('div.f6.mt1.truncate', {
                    class: ctrl.builderSaveIsError() ? 'red' : 'green'
                  }, ctrl.builderSaveStatus())
                : null
              ])
            : null,
            ctrl.isPointBrowseVariant() ? null :
              m('i.ion-close.blue.pointer.f3' + (ctrl.isBuilderVariant() ? '.mr3' : (ctrl.expandedCloseIconMargin ? '.' + ctrl.expandedCloseIconMargin : '')), {
                onclick: function (event) {
                  event.stopPropagation();
                  ctrl.toggleExpanded(event);
                }
              })
          ])
        ]),
        m('div', {
          class: 'smart-chart-toolbar flex flex-wrap w-100 ' + (isPointBrowse ? 'justify-start' : 'justify-between')
        }, [
          m('div.smart-chart-series-controls.flex.items-center.mv2', [
            ctrl.renderValueFieldSelector({
              id: inlineValueFieldId,
              className: 'mr2 mv2',
              selectStyle: { 'min-height': 'auto', 'padding-left': '0.5rem', 'padding-right': '0.5rem' },
            }),
            ctrl.renderYBoundsControl()
          ]),
          m('div.smart-chart-range-controls.flex.justify-center.items-center.mv2', [
            ctrl.renderShiftControl({
              fraction: 0.9,
              direction: 'backward',
              iconCount: 2,
              className: 'smart-chart-shift-back-far mr3'
            }),
            ctrl.renderShiftControl({
              fraction: 0.1,
              direction: 'backward',
              iconCount: 1,
              className: 'smart-chart-shift-back-near mr2'
            }),
            m('div.smart-chart-date-edit.ba.br3.ph2.pv1.dib.f5.pointer.mh2', {
              style: { backgroundColor: '#212121' },
              onclick: function (event) {
                event.stopPropagation();
                ctrl.closeYBoundsPopover();
                ctrl.controlsOpen(!ctrl.controlsOpen());
              }
            }, [
              m('i.ion-edit.blue.mr2'),
              m('span', expandedSummary)
            ]),
            ctrl.renderShiftControl({
              fraction: 0.1,
              direction: 'forward',
              iconCount: 1,
              className: 'smart-chart-shift-forward-near ml2'
            }),
            ctrl.renderShiftControl({
              fraction: 0.9,
              direction: 'forward',
              iconCount: 2,
              className: 'smart-chart-shift-forward-far ml3'
            })
          ])
        ])
      ]);
    }

    var headerChildren = [headerInner];
    if (!isEditing && ctrl.controlsOpen()) {
      var popover = ctrl.renderControlsPopover();
      if (popover) { headerChildren.push(popover); }
    }

    var headerNode = m('div.relative', headerChildren);

    var content = [headerNode];

    var shouldRenderBody = isExpanded || ctrl.hasInitialized;
    var bodyChildren = [];

    if (shouldRenderBody) {
      if (ctrl.loading()) {
        bodyChildren.push(
          m('div.tc', [
            m('img', {
              src: '/images/loading-bars.svg',
              style: { width: '100px', height: '100px' },
              alt: 'Loading Chart'
            })
          ])
        );
      } else {
        var shouldShowBodyError = ctrl.error() && !ctrl.isBuilderVariant();
        if (shouldShowBodyError) {
          bodyChildren.push(m('div.red', ctrl.error()));
        }
        if (isEditing) {
          bodyChildren.push(
            m('div', [
              ctrl.renderDatasets()
            ])
          );
        } else {
          bodyChildren.push(ctrl.renderChart());
          var rangeLabels = ctrl.renderPointBrowseRangeLabels();
          if (rangeLabels) {
            bodyChildren.push(rangeLabels);
          }
          var legends = ctrl.renderPointLegends();
          if (legends) {
            bodyChildren.push(legends);
          }
        }
      }
    }

    if (bodyChildren.length) {
      var bodyClass = isPointBrowse ? '' : 'ml1 pl1';
      var bodyStyle = {
        opacity: isExpanded ? 1 : 0,
        overflow: isExpanded ? 'visible' : 'hidden',
        pointerEvents: isExpanded ? 'auto' : 'none',
        transition: 'max-height 220ms ease, opacity 180ms ease'
      };
      if (isEditing) {
        bodyStyle.maxHeight = 'none';
      }
      var updateBodyHeight = function (element) {
        if (!element) { return; }
        var data = element.dataset || (element.dataset = {});
        var wasExpanded = data.smartChartExpanded === 'true';
        data.smartChartExpanded = isExpanded ? 'true' : 'false';
        if (isEditing) {
          element.style.maxHeight = 'none';
          return;
        }
        if (isExpanded) {
          var targetHeight = element.scrollHeight;
          element.style.maxHeight = targetHeight ? (targetHeight + 'px') : 'none';
          return;
        }
        if (wasExpanded) {
          var collapseHeight = element.scrollHeight;
          element.style.maxHeight = collapseHeight ? (collapseHeight + 'px') : '0px';
          var raf = (typeof window !== 'undefined' && window.requestAnimationFrame) ? window.requestAnimationFrame : function (cb) { return setTimeout(cb, 0); };
          raf(function () {
            element.style.maxHeight = '0px';
          });
        } else {
          element.style.maxHeight = '0px';
        }
      };
      var bodyAttrs = {
        class: bodyClass,
        style: bodyStyle,
        'aria-hidden': isExpanded ? 'false' : 'true',
        ontransitionend: function (event) {
          if (!event || event.target !== event.currentTarget) {
            return;
          }
          ctrl.scheduleChartRefresh();
          if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
            window.dispatchEvent(new Event('resize'));
          }
          if (isExpanded) {
            event.currentTarget.style.maxHeight = 'none';
          }
          m.redraw();
        },
        oncreate: function (vnode) {
          updateBodyHeight(vnode.dom);
        },
        onupdate: function (vnode) {
          updateBodyHeight(vnode.dom);
        }
      };
      content.push(
        m('div', bodyAttrs, bodyChildren)
      );
    }

    return m('div' + (isPointBrowse ? '' : '.pl2'), {
      class: containerClass.trim(),
      style: containerStyle,
      oncreate: function (vnode) {
        ctrl.attachModalDateControlsListener(vnode.dom);
      }
    }, content);
  }
};

module.exports = smartChart;
